/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** AcceptedInput */
/** @see {@link ConversationMessageDiscriminator.AcceptedInput} */
export interface AcceptedInput {
  value: ConversationInput;
  /** @see {@link ConversationMessageDiscriminator.AcceptedInput} */
  type: typeof ConversationMessageDiscriminator.AcceptedInput;
}

/** Account */
/** @see {@link GuestMatchDiscriminator.Account} */
export interface Account {
  /** @pattern [^\s\\/]+ */
  accountId: string;
  /** @see {@link GuestMatchDiscriminator.Account} */
  type: typeof GuestMatchDiscriminator.Account;
}

/** AccountId */
/** @see {@link CrmIdDiscriminator.AccountId} */
export interface AccountId {
  value: string;
  /** @see {@link CrmIdDiscriminator.AccountId} */
  type: typeof CrmIdDiscriminator.AccountId;
}

/** Alias */

export const Alias = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AnyAccount: "AnyAccount",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AnyCase: "AnyCase",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AnyOpportunity: "AnyOpportunity",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AnyLead: "AnyLead",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AnyContact: "AnyContact",
} as const;
export type Alias = "AnyAccount" | "AnyCase" | "AnyOpportunity" | "AnyLead" | "AnyContact";

/** AliasedDataObjectReference */
export interface AliasedDataObjectReference {
  source: DataSource;
  object: DataObjectOrAlias;
}

/** AliasedDataReference */
export interface AliasedDataReference {
  source: DataSource;
  object: DataObjectOrAlias;
  field: DataField;
}

/** AliasedOwnershipReference */
export interface AliasedOwnershipReference {
  source: DataSource;
  object: DataObjectOrAlias;
  field: DataField;
}

/** All */
/** @see {@link ReportingPlaybookFilterDiscriminator.All} */
export interface All {
  /** @see {@link ReportingPlaybookFilterDiscriminator.All} */
  type: typeof ReportingPlaybookFilterDiscriminator.All;
}

/** All */
/** @see {@link ReportingUserFilterDiscriminator.All} */
export interface All1 {
  /** @see {@link ReportingUserFilterDiscriminator.All} */
  type: typeof ReportingUserFilterDiscriminator.All;
}

/** AlwaysTrueLeaf */
/** @see {@link RuleEvaluationTreeDiscriminator.AlwaysTrueLeaf} */
export interface AlwaysTrueLeaf {
  /** @see {@link RuleEvaluationTreeDiscriminator.AlwaysTrueLeaf} */
  type: typeof RuleEvaluationTreeDiscriminator.AlwaysTrueLeaf;
}

/** AnalyticsSchedulingAssignee */

export const AnalyticsSchedulingAssigneeDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Individual: "Individual",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LiveChat: "LiveChat",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Owner: "Owner",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Team: "Team",
} as const;
export type AnalyticsSchedulingAssigneeDiscriminator = "Individual" | "LiveChat" | "Owner" | "Team";

/** @see {@link AnalyticsSchedulingAssigneeDiscriminator} */
export type AnalyticsSchedulingAssignee =
  | ({
      type: "Individual";
    } & Individual2)
  | ({
      type: "LiveChat";
    } & LiveChat1)
  | ({
      type: "Owner";
    } & Owner1)
  | ({
      type: "Team";
    } & Team1);

/** AnalyticsSchedulingAssignment */
export interface AnalyticsSchedulingAssignment {
  configured: AnalyticsSchedulingAssignee;
  /** @minItems 1 */
  resultedAssignee?: string[];
}

/**
 * AnyDataObjectId
 * @pattern [^\s\\/]+
 */
export type AnyDataObjectId = string;

/** AnyDataObjectValues */
/** @see {@link DataObjectValuesDiscriminator.AnyDataObjectValues} */
export interface AnyDataObjectValues {
  fields: MapDataFieldStaticValue;
  /** @see {@link DataObjectValuesDiscriminator.AnyDataObjectValues} */
  type: typeof DataObjectValuesDiscriminator.AnyDataObjectValues;
}

/** AnyValueFound */
/** @see {@link EvaluatedExistenceDiscriminator.AnyValueFound} */
export interface AnyValueFound {
  /** @see {@link EvaluatedExistenceDiscriminator.AnyValueFound} */
  type: typeof EvaluatedExistenceDiscriminator.AnyValueFound;
}

/** AnyValueFromDataSource */
/** @see {@link ValueSourceDiscriminator.AnyValueFromDataSource} */
export interface AnyValueFromDataSource {
  ref: AliasedDataObjectReference;
  /** @see {@link ValueSourceDiscriminator.AnyValueFromDataSource} */
  type: typeof ValueSourceDiscriminator.AnyValueFromDataSource;
}

/** Array_EvaluatedOwnership */
export type ArrayEvaluatedOwnership = EvaluatedOwnership[];

/** Array_OwnerInTeam */
export type ArrayOwnerInTeam = OwnerInTeam[];

/** AskTheGuest */
/** @see {@link PickedMeetingLocationDiscriminator.AskTheGuest} */
export interface AskTheGuest {
  /** @minLength 1 */
  value?: string;
  /** @see {@link PickedMeetingLocationDiscriminator.AskTheGuest} */
  type: typeof PickedMeetingLocationDiscriminator.AskTheGuest;
}

/** AssignToAssignee */
/** @see {@link AssigneeLogEntryDiscriminator.AssignToAssignee} */
export interface AssignToAssignee {
  id: UserId;
  /** @see {@link AssigneeLogEntryDiscriminator.AssignToAssignee} */
  type: typeof AssigneeLogEntryDiscriminator.AssignToAssignee;
}

/** AssignToLogDetails */
export interface AssignToLogDetails {
  assigneeId: UserId;
  /** @format date-time */
  timestamp: string;
}

/** AssigneeLogEntry */

export const AssigneeLogEntryDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AssignToAssignee: "AssignToAssignee",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  InboxAssignee: "InboxAssignee",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LiveChatAssignee: "LiveChatAssignee",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MeetingAssignee: "MeetingAssignee",
} as const;
export type AssigneeLogEntryDiscriminator =
  | "AssignToAssignee"
  | "InboxAssignee"
  | "LiveChatAssignee"
  | "MeetingAssignee";

/** @see {@link AssigneeLogEntryDiscriminator} */
export type AssigneeLogEntry =
  | ({
      type: "AssignToAssignee";
    } & AssignToAssignee)
  | ({
      type: "InboxAssignee";
    } & InboxAssignee)
  | ({
      type: "LiveChatAssignee";
    } & LiveChatAssignee)
  | ({
      type: "MeetingAssignee";
    } & MeetingAssignee);

/** AutomationToken */
/** @see {@link CallerRefDiscriminator.AutomationToken} */
export interface AutomationToken {
  id: AutomationTokenId;
  /** @see {@link CallerRefDiscriminator.AutomationToken} */
  type: typeof CallerRefDiscriminator.AutomationToken;
}

/**
 * AutomationTokenId
 * @pattern [^\s\\/]+
 */
export type AutomationTokenId = string;

/** AvailableUsersFound */
/** @see {@link TimelineEventDiscriminator.AvailableUsersFound} */
export interface AvailableUsersFound {
  /** @format date-time */
  created: string;
  /** @minItems 1 */
  users: UserId[];
  /** @see {@link TimelineEventDiscriminator.AvailableUsersFound} */
  type: typeof TimelineEventDiscriminator.AvailableUsersFound;
}

/** BookMeetingReached */
/** @see {@link TimelineEventDiscriminator.BookMeetingReached} */
export interface BookMeetingReached {
  /** @format date-time */
  created: string;
  assignment?: AnalyticsSchedulingAssignment;
  /** @see {@link TimelineEventDiscriminator.BookMeetingReached} */
  type: typeof TimelineEventDiscriminator.BookMeetingReached;
}

/** BotEnvelope */
/** @see {@link EnvelopeInDiscriminator.BotEnvelope} */
export interface BotEnvelope {
  payload: ConversationInput;
  /** @format date-time */
  createdAt: string;
  /** @format int64 */
  envelopeId: number;
  /** @format int64 */
  protocolVersion: number;
  baggage?: MapStringString;
  /** @see {@link EnvelopeInDiscriminator.BotEnvelope} */
  type: typeof EnvelopeInDiscriminator.BotEnvelope;
}

/** BotEnvelopeOut */
/** @see {@link EnvelopeOutDiscriminator.BotEnvelopeOut} */
export interface BotEnvelopeOut {
  payload: PayloadOut;
  /** @format int64 */
  envelopeId: number;
  /** @format date-time */
  createdAt: string;
  /** @format int64 */
  protocolVersion: number;
  baggage?: MapStringString;
  /** @see {@link EnvelopeOutDiscriminator.BotEnvelopeOut} */
  type: typeof EnvelopeOutDiscriminator.BotEnvelopeOut;
}

/** BrowserLanguage */
/** @see {@link LocationConditionRequestDiscriminator.BrowserLanguage} */
export interface BrowserLanguage {
  /** @pattern [^\s\\/]+ */
  conditionId: string;
  operator: BrowserLanguageOperator;
  /** @uniqueItems true */
  values?: string[];
  /** @see {@link LocationConditionRequestDiscriminator.BrowserLanguage} */
  type: typeof LocationConditionRequestDiscriminator.BrowserLanguage;
}

/** BrowserLanguageOperator */

export const BrowserLanguageOperator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  IsAnyOf: "isAnyOf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  IsNotAnyOf: "isNotAnyOf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Equals: "equals",
} as const;
export type BrowserLanguageOperator = "isAnyOf" | "isNotAnyOf" | "equals";

/** ButtonSelected */
export interface ButtonSelected {
  /** @format int32 */
  buttonIndex: number;
  /** @format date-time */
  timestamp: string;
}

/** CalendarPlatformConference */
/** @see {@link PickedMeetingLocationDiscriminator.CalendarPlatformConference} */
export interface CalendarPlatformConference {
  /** @see {@link PickedMeetingLocationDiscriminator.CalendarPlatformConference} */
  type: typeof PickedMeetingLocationDiscriminator.CalendarPlatformConference;
}

/** CalendarSubscription */
/** @see {@link CallerRefDiscriminator.CalendarSubscription} */
export interface CalendarSubscription {
  id: CalendarSubscriptionRef;
  /** @see {@link CallerRefDiscriminator.CalendarSubscription} */
  type: typeof CallerRefDiscriminator.CalendarSubscription;
}

/**
 * CalendarSubscriptionRef
 * @pattern [^\s\\/]+
 */
export type CalendarSubscriptionRef = string;

/** CallerRef */

export const CallerRefDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AutomationToken: "AutomationToken",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CalendarSubscription: "CalendarSubscription",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ChiliAdmin: "ChiliAdmin",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CrmSubscription: "CrmSubscription",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  GuestSession: "GuestSession",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Integration: "Integration",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  InternalService: "InternalService",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Job: "Job",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RawCallerRef: "RawCallerRef",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  User: "User",
} as const;
export type CallerRefDiscriminator =
  | "AutomationToken"
  | "CalendarSubscription"
  | "ChiliAdmin"
  | "CrmSubscription"
  | "GuestSession"
  | "Integration"
  | "InternalService"
  | "Job"
  | "RawCallerRef"
  | "User";

/** @see {@link CallerRefDiscriminator} */
export type CallerRef =
  | ({
      type: "AutomationToken";
    } & AutomationToken)
  | ({
      type: "CalendarSubscription";
    } & CalendarSubscription)
  | ({
      type: "ChiliAdmin";
    } & ChiliAdmin)
  | ({
      type: "CrmSubscription";
    } & CrmSubscription)
  | ({
      type: "GuestSession";
    } & GuestSession)
  | ({
      type: "Integration";
    } & Integration)
  | ({
      type: "InternalService";
    } & InternalService)
  | ({
      type: "Job";
    } & Job)
  | ({
      type: "RawCallerRef";
    } & any)
  | ({
      type: "User";
    } & User);

/** ChatDataFieldDataType */

export const ChatDataFieldDataTypeDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Checkbox: "Checkbox",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Email: "Email",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LongText: "LongText",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Number: "Number",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Phone: "Phone",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Picklist: "Picklist",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RadioButton: "RadioButton",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ShortText: "ShortText",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TrueFalse: "TrueFalse",
} as const;
export type ChatDataFieldDataTypeDiscriminator =
  | "Checkbox"
  | "Email"
  | "LongText"
  | "Number"
  | "Phone"
  | "Picklist"
  | "RadioButton"
  | "ShortText"
  | "TrueFalse";

/** @see {@link ChatDataFieldDataTypeDiscriminator} */
export type ChatDataFieldDataType =
  | ({
      type: "Checkbox";
    } & Checkbox)
  | ({
      type: "Email";
    } & Email1)
  | ({
      type: "LongText";
    } & LongText)
  | ({
      type: "Number";
    } & Number)
  | ({
      type: "Phone";
    } & Phone1)
  | ({
      type: "Picklist";
    } & Picklist)
  | ({
      type: "RadioButton";
    } & RadioButton)
  | ({
      type: "ShortText";
    } & ShortText)
  | ({
      type: "TrueFalse";
    } & TrueFalse);

/** Checkbox */
/** @see {@link ChatDataFieldDataTypeDiscriminator.Checkbox} */
export interface Checkbox {
  /** @minItems 1 */
  values: string[];
  /** @see {@link ChatDataFieldDataTypeDiscriminator.Checkbox} */
  type: typeof ChatDataFieldDataTypeDiscriminator.Checkbox;
}

/** CheckboxField */
/** @see {@link FormDataFieldDiscriminator.CheckboxField} */
export interface CheckboxField {
  value: string;
  /** @see {@link FormDataFieldDiscriminator.CheckboxField} */
  type: typeof FormDataFieldDiscriminator.CheckboxField;
}

/** ChiliAdmin */
/** @see {@link CallerRefDiscriminator.ChiliAdmin} */
export interface ChiliAdmin {
  id: Email;
  /** @see {@link CallerRefDiscriminator.ChiliAdmin} */
  type: typeof CallerRefDiscriminator.ChiliAdmin;
}

/** CloseAllRelatedInboxes */
/** @see {@link InboxManagementRequestDtoDiscriminator.CloseAllRelatedInboxes} */
export interface CloseAllRelatedInboxes {
  /** @format uuid */
  guestId: string;
  /** @see {@link InboxManagementRequestDtoDiscriminator.CloseAllRelatedInboxes} */
  type: typeof InboxManagementRequestDtoDiscriminator.CloseAllRelatedInboxes;
}

/** ComparisonError */

export const ComparisonErrorDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ObjectDoesNotExistAndCouldNotBeResolved: "ObjectDoesNotExistAndCouldNotBeResolved",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TeamCouldNotBeResolved: "TeamCouldNotBeResolved",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  UndefinedOperationBetweenTypes: "UndefinedOperationBetweenTypes",
} as const;
export type ComparisonErrorDiscriminator =
  | "ObjectDoesNotExistAndCouldNotBeResolved"
  | "TeamCouldNotBeResolved"
  | "UndefinedOperationBetweenTypes";

/** @see {@link ComparisonErrorDiscriminator} */
export type ComparisonError =
  | ({
      type: "ObjectDoesNotExistAndCouldNotBeResolved";
    } & ObjectDoesNotExistAndCouldNotBeResolved)
  | ({
      type: "TeamCouldNotBeResolved";
    } & TeamCouldNotBeResolved)
  | ({
      type: "UndefinedOperationBetweenTypes";
    } & UndefinedOperationBetweenTypes);

/** Completed */
/** @see {@link MeetingStateDiscriminator.Completed} */
export interface Completed {
  meetingId: MeetingId;
  /** @see {@link MeetingStateDiscriminator.Completed} */
  type: typeof MeetingStateDiscriminator.Completed;
}

/** Completed */
/** @see {@link CrmSyncStateDiscriminator.Completed} */
export interface Completed1 {
  data: CrmData;
  /** @see {@link CrmSyncStateDiscriminator.Completed} */
  type: typeof CrmSyncStateDiscriminator.Completed;
}

/**
 * ConditionId
 * @pattern [^\s\\/]+
 */
export type ConditionId = string;

/** Contact */
/** @see {@link GuestMatchDiscriminator.Contact} */
export interface Contact {
  id: CrmContactId;
  /** @pattern [^\s\\/]+ */
  accountId: string;
  /** @see {@link GuestMatchDiscriminator.Contact} */
  type: typeof GuestMatchDiscriminator.Contact;
}

/** ContactId */
/** @see {@link CrmIdDiscriminator.ContactId} */
export interface ContactId {
  value: string;
  /** @see {@link CrmIdDiscriminator.ContactId} */
  type: typeof CrmIdDiscriminator.ContactId;
}

/** Content */
/** @see {@link ConversationMessageDiscriminator.Content} */
export interface Content {
  /** @minItems 1 */
  value: MessagePart[];
  /** @see {@link ConversationMessageDiscriminator.Content} */
  type: typeof ConversationMessageDiscriminator.Content;
}

/** Conversation */
export interface Conversation {
  assigneeId: UserId;
  /** @format date-time */
  routedAt: string;
}

/** ConversationAction */

export const ConversationActionDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RepJoinOrTimeoutAction: "RepJoinOrTimeoutAction",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ResumeNodeExecution: "ResumeNodeExecution",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SelectDataFieldPicklistReplyAction: "SelectDataFieldPicklistReplyAction",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SelectMeetingSlotAction: "SelectMeetingSlotAction",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SelectReplyAction: "SelectReplyAction",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  StartLiveChat: "StartLiveChat",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SubmitFormAction: "SubmitFormAction",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SubmitFormActionError: "SubmitFormActionError",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SubmitFormEntry: "SubmitFormEntry",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TerminateConversation: "TerminateConversation",
} as const;
export type ConversationActionDiscriminator =
  | "RepJoinOrTimeoutAction"
  | "ResumeNodeExecution"
  | "SelectDataFieldPicklistReplyAction"
  | "SelectMeetingSlotAction"
  | "SelectReplyAction"
  | "StartLiveChat"
  | "SubmitFormAction"
  | "SubmitFormActionError"
  | "SubmitFormEntry"
  | "TerminateConversation";

/** @see {@link ConversationActionDiscriminator} */
export type ConversationAction =
  | ({
      type: "RepJoinOrTimeoutAction";
    } & RepJoinOrTimeoutAction)
  | ({
      type: "ResumeNodeExecution";
    } & ResumeNodeExecution)
  | ({
      type: "SelectDataFieldPicklistReplyAction";
    } & SelectDataFieldPicklistReplyAction)
  | ({
      type: "SelectMeetingSlotAction";
    } & SelectMeetingSlotAction)
  | ({
      type: "SelectReplyAction";
    } & SelectReplyAction)
  | ({
      type: "StartLiveChat";
    } & StartLiveChat)
  | ({
      type: "SubmitFormAction";
    } & SubmitFormAction)
  | ({
      type: "SubmitFormActionError";
    } & SubmitFormActionError)
  | ({
      type: "SubmitFormEntry";
    } & SubmitFormEntry1)
  | ({
      type: "TerminateConversation";
    } & TerminateConversation);

/** ConversationAssignedSource */

export const ConversationAssignedSourceDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Directly: "Directly",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FromInbox: "FromInbox",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FromMeetingAssignment: "FromMeetingAssignment",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FromTeam: "FromTeam",
} as const;
export type ConversationAssignedSourceDiscriminator = "Directly" | "FromInbox" | "FromMeetingAssignment" | "FromTeam";

/** @see {@link ConversationAssignedSourceDiscriminator} */
export type ConversationAssignedSource =
  | ({
      type: "Directly";
    } & Directly)
  | ({
      type: "FromInbox";
    } & FromInbox)
  | ({
      type: "FromMeetingAssignment";
    } & FromMeetingAssignment)
  | ({
      type: "FromTeam";
    } & FromTeam);

/** ConversationAssignmentMethod */

export const ConversationAssignmentMethodDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CrmOwnership: "CrmOwnership",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  EveryoneInTeam: "EveryoneInTeam",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FlexibleRoundRobin: "FlexibleRoundRobin",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Inbox: "Inbox",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Individual: "Individual",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  StrictRoundRobin: "StrictRoundRobin",
} as const;
export type ConversationAssignmentMethodDiscriminator =
  | "CrmOwnership"
  | "EveryoneInTeam"
  | "FlexibleRoundRobin"
  | "Inbox"
  | "Individual"
  | "StrictRoundRobin";

/** @see {@link ConversationAssignmentMethodDiscriminator} */
export type ConversationAssignmentMethod =
  | ({
      type: "CrmOwnership";
    } & CrmOwnership)
  | ({
      type: "EveryoneInTeam";
    } & EveryoneInTeam)
  | ({
      type: "FlexibleRoundRobin";
    } & FlexibleRoundRobin)
  | ({
      type: "Inbox";
    } & Inbox)
  | ({
      type: "Individual";
    } & Individual3)
  | ({
      type: "StrictRoundRobin";
    } & StrictRoundRobin);

/** ConversationData */
export interface ConversationData {
  /** @format uuid */
  id: string;
  messages?: ConversationMessage[];
  action: ConversationAction;
}

/** ConversationData */
/** @see {@link PayloadOutDiscriminator.ConversationData} */
export interface ConversationData1 {
  /** @format uuid */
  id: string;
  messages?: ConversationMessage[];
  action: ConversationAction;
  /** @see {@link PayloadOutDiscriminator.ConversationData} */
  type: typeof PayloadOutDiscriminator.ConversationData;
}

/** ConversationInput */

export const ConversationInputDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FormData: "FormData",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MeetingSlotSelectedWithReservation: "MeetingSlotSelectedWithReservation",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MeetingSlotSelectedWithoutReservation: "MeetingSlotSelectedWithoutReservation",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MeetingSlotSelectionCancelled: "MeetingSlotSelectionCancelled",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NodeExecutionResumed: "NodeExecutionResumed",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NodeExecutionTimedout: "NodeExecutionTimedout",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RepSentMessage: "RepSentMessage",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ReplyButtonSelected: "ReplyButtonSelected",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Start: "Start",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  WaitingForRepHasTimedout: "WaitingForRepHasTimedout",
} as const;
export type ConversationInputDiscriminator =
  | "FormData"
  | "MeetingSlotSelectedWithReservation"
  | "MeetingSlotSelectedWithoutReservation"
  | "MeetingSlotSelectionCancelled"
  | "NodeExecutionResumed"
  | "NodeExecutionTimedout"
  | "RepSentMessage"
  | "ReplyButtonSelected"
  | "Start"
  | "WaitingForRepHasTimedout";

/** @see {@link ConversationInputDiscriminator} */
export type ConversationInput =
  | ({
      type: "FormData";
    } & FormData)
  | ({
      type: "MeetingSlotSelectedWithReservation";
    } & MeetingSlotSelectedWithReservation)
  | ({
      type: "MeetingSlotSelectedWithoutReservation";
    } & MeetingSlotSelectedWithoutReservation)
  | ({
      type: "MeetingSlotSelectionCancelled";
    } & MeetingSlotSelectionCancelled)
  | ({
      type: "NodeExecutionResumed";
    } & NodeExecutionResumed)
  | ({
      type: "NodeExecutionTimedout";
    } & NodeExecutionTimedout)
  | ({
      type: "RepSentMessage";
    } & RepSentMessage)
  | ({
      type: "ReplyButtonSelected";
    } & ReplyButtonSelected)
  | ({
      type: "Start";
    } & Start)
  | ({
      type: "WaitingForRepHasTimedout";
    } & WaitingForRepHasTimedout);

/** ConversationMessage */

export const ConversationMessageDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AcceptedInput: "AcceptedInput",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Content: "Content",
} as const;
export type ConversationMessageDiscriminator = "AcceptedInput" | "Content";

/** @see {@link ConversationMessageDiscriminator} */
export type ConversationMessage =
  | ({
      type: "AcceptedInput";
    } & AcceptedInput)
  | ({
      type: "Content";
    } & Content);

/** ConversationSessionExpired */
/** @see {@link PayloadOutDiscriminator.ConversationSessionExpired} */
export interface ConversationSessionExpired {
  /** @format int32 */
  sessionId: number;
  /** @see {@link PayloadOutDiscriminator.ConversationSessionExpired} */
  type: typeof PayloadOutDiscriminator.ConversationSessionExpired;
}

/** CrmContactId */
export interface CrmContactId {
  /** @pattern [^\s\\/]+ */
  value: string;
}

/** CrmData */

export const CrmDataDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SalesforceData: "SalesforceData",
} as const;
export type CrmDataDiscriminator = "SalesforceData";

/** @see {@link CrmDataDiscriminator} */
export type CrmData = {
  type: "SalesforceData";
} & SalesforceData;

/** CrmId */

export const CrmIdDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AccountId: "AccountId",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ContactId: "ContactId",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LeadId: "LeadId",
} as const;
export type CrmIdDiscriminator = "AccountId" | "ContactId" | "LeadId";

/** @see {@link CrmIdDiscriminator} */
export type CrmId =
  | ({
      type: "AccountId";
    } & AccountId)
  | ({
      type: "ContactId";
    } & ContactId)
  | ({
      type: "LeadId";
    } & LeadId);

/** CrmLeadId */
export interface CrmLeadId {
  /** @pattern [^\s\\/]+ */
  value: string;
}

/** CrmOwnership */
/** @see {@link ConversationAssignmentMethodDiscriminator.CrmOwnership} */
export interface CrmOwnership {
  /** @see {@link ConversationAssignmentMethodDiscriminator.CrmOwnership} */
  type: typeof ConversationAssignmentMethodDiscriminator.CrmOwnership;
}

/** CrmOwnership */
/** @see {@link MeetingAssignmentMethodDiscriminator.CrmOwnership} */
export interface CrmOwnership1 {
  /** @see {@link MeetingAssignmentMethodDiscriminator.CrmOwnership} */
  type: typeof MeetingAssignmentMethodDiscriminator.CrmOwnership;
}

/** CrmOwnershipMeeting */
export interface CrmOwnershipMeeting {
  assigneeId: UserId;
}

/** CrmSubscription */
/** @see {@link CallerRefDiscriminator.CrmSubscription} */
export interface CrmSubscription {
  id: CrmSubscriptionRef;
  /** @see {@link CallerRefDiscriminator.CrmSubscription} */
  type: typeof CallerRefDiscriminator.CrmSubscription;
}

/**
 * CrmSubscriptionRef
 * @pattern [^\s\\/]+
 */
export type CrmSubscriptionRef = string;

/** CrmSyncInfo */
export interface CrmSyncInfo {
  delayInterval: string;
  /** @format date-time */
  lastLiveChatActivity?: string;
  /** @format date-time */
  nextUpdateAt: string;
}

/** CrmSyncState */

export const CrmSyncStateDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Completed: "Completed",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Delayed: "Delayed",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Failed: "Failed",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Requested: "Requested",
} as const;
export type CrmSyncStateDiscriminator = "Completed" | "Delayed" | "Failed" | "Requested";

/** @see {@link CrmSyncStateDiscriminator} */
export type CrmSyncState =
  | ({
      type: "Completed";
    } & Completed1)
  | ({
      type: "Delayed";
    } & Delayed)
  | ({
      type: "Failed";
    } & Failed)
  | ({
      type: "Requested";
    } & Requested1);

/** CrmSyncWithNextUpdate */
export interface CrmSyncWithNextUpdate {
  state: CrmSyncState;
  nextUpdate?: CrmSyncInfo;
}

/** Custom */
/** @see {@link ReportingTimeframeDiscriminator.Custom} */
export interface Custom {
  /** @format date-time */
  inclusiveStart?: string;
  /** @format date-time */
  exclusiveEnd?: string;
  /** @see {@link ReportingTimeframeDiscriminator.Custom} */
  type: typeof ReportingTimeframeDiscriminator.Custom;
}

/**
 * DataField
 * @pattern [^\s\\/]+
 */
export type DataField = string;

/** DataFieldPicklistEntry */
/** @see {@link GuestValueDiscriminator.DataFieldPicklistEntry} */
export interface DataFieldPicklistEntry {
  value: string;
  /** @see {@link GuestValueDiscriminator.DataFieldPicklistEntry} */
  type: typeof GuestValueDiscriminator.DataFieldPicklistEntry;
}

/** DataFieldPicklistReplyButton */
export interface DataFieldPicklistReplyButton {
  text: string;
  target: NodeExit;
  mapping: string;
}

/**
 * DataFieldRef
 * @pattern [^\s\\/]+
 */
export type DataFieldRef = string;

/** DataObject */
export type DataObject = MatchedObject | NormalDataObject | RelatedChildObjectRef | RelatedDataObjectSimpleDataObject;

/** DataObjectOrAlias */
export type DataObjectOrAlias =
  | Alias
  | MatchedObject
  | NormalDataObject
  | RelatedChildObjectRef
  | RelatedDataObjectSimpleDataObject;

/** DataObjectValues */

export const DataObjectValuesDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AnyDataObjectValues: "AnyDataObjectValues",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DataObjectWithId: "DataObjectWithId",
} as const;
export type DataObjectValuesDiscriminator = "AnyDataObjectValues" | "DataObjectWithId";

/** @see {@link DataObjectValuesDiscriminator} */
export type DataObjectValues =
  | ({
      type: "AnyDataObjectValues";
    } & AnyDataObjectValues)
  | ({
      type: "DataObjectWithId";
    } & DataObjectWithId);

/** DataObjectWithId */
/** @see {@link DataObjectValuesDiscriminator.DataObjectWithId} */
export interface DataObjectWithId {
  id: AnyDataObjectId;
  fields: MapDataFieldStaticValue;
  /** @see {@link DataObjectValuesDiscriminator.DataObjectWithId} */
  type: typeof DataObjectValuesDiscriminator.DataObjectWithId;
}

/** DataReference */
export interface DataReference {
  source: DataSource;
  object: DataObject;
  field: DataField;
}

/** DataSource */

export const DataSource = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Sf: "SF",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Df: "DF",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Cp: "CP",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Hs: "HS",
} as const;
export type DataSource = "SF" | "DF" | "CP" | "HS";

/** DecodingFailure */
/** @see {@link PayloadOutDiscriminator.DecodingFailure} */
export interface DecodingFailure {
  reason: string;
  /** @see {@link PayloadOutDiscriminator.DecodingFailure} */
  type: typeof PayloadOutDiscriminator.DecodingFailure;
}

/** DefaultFieldsValue */
/** @see {@link GuestValueDiscriminator.DefaultFieldsValue} */
export interface DefaultFieldsValue {
  value: FormDataField;
  /** @see {@link GuestValueDiscriminator.DefaultFieldsValue} */
  type: typeof GuestValueDiscriminator.DefaultFieldsValue;
}

/** DefinedInMeetingType */
/** @see {@link PickedMeetingLocationDiscriminator.DefinedInMeetingType} */
export interface DefinedInMeetingType {
  /** @minLength 1 */
  value?: string;
  /** @see {@link PickedMeetingLocationDiscriminator.DefinedInMeetingType} */
  type: typeof PickedMeetingLocationDiscriminator.DefinedInMeetingType;
}

/** Delayed */
/** @see {@link CrmSyncStateDiscriminator.Delayed} */
export interface Delayed {
  /** @format date-time */
  executionPlannedAt: string;
  mostRecentData?: CrmData;
  /** @see {@link CrmSyncStateDiscriminator.Delayed} */
  type: typeof CrmSyncStateDiscriminator.Delayed;
}

/** DeviceType */
/** @see {@link LocationConditionRequestDiscriminator.DeviceType} */
export interface DeviceType {
  /** @pattern [^\s\\/]+ */
  conditionId: string;
  operator: DeviceTypeOperator;
  /** @uniqueItems true */
  values?: DeviceTypeValue[];
  /** @see {@link LocationConditionRequestDiscriminator.DeviceType} */
  type: typeof LocationConditionRequestDiscriminator.DeviceType;
}

/** DeviceTypeOperator */

export const DeviceTypeOperator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  IsAnyOf: "isAnyOf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  IsNotAnyOf: "isNotAnyOf",
} as const;
export type DeviceTypeOperator = "isAnyOf" | "isNotAnyOf";

/** DeviceTypeValue */

export const DeviceTypeValue = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Mobile: "Mobile",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Tablet: "Tablet",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Desktop: "Desktop",
} as const;
export type DeviceTypeValue = "Mobile" | "Tablet" | "Desktop";

/** Directly */
/** @see {@link ConversationAssignedSourceDiscriminator.Directly} */
export interface Directly {
  /** @see {@link ConversationAssignedSourceDiscriminator.Directly} */
  type: typeof ConversationAssignedSourceDiscriminator.Directly;
}

/** DisplaySettings */

export const DisplaySettingsDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Passive: "Passive",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Pushy: "Pushy",
} as const;
export type DisplaySettingsDiscriminator = "Passive" | "Pushy";

/** @see {@link DisplaySettingsDiscriminator} */
export type DisplaySettings =
  | ({
      type: "Passive";
    } & Passive)
  | ({
      type: "Pushy";
    } & Pushy);

/**
 * DistributionId
 * @pattern [^\s\\/]+
 */
export type DistributionId = string;

/**
 * Email
 * @pattern .+@.+
 */
export type Email = string;

/** Email */
/** @see {@link ChatDataFieldDataTypeDiscriminator.Email} */
export interface Email1 {
  /** @see {@link ChatDataFieldDataTypeDiscriminator.Email} */
  type: typeof ChatDataFieldDataTypeDiscriminator.Email;
}

/**
 * Email
 * @pattern .+@.+
 */
export type Email2 = string;

/** EmailChangeRequestDto */
export interface EmailChangeRequestDto {
  email: Email;
}

/** EmailField */
/** @see {@link FormDataFieldDiscriminator.EmailField} */
export interface EmailField {
  value: Email;
  /** @see {@link FormDataFieldDiscriminator.EmailField} */
  type: typeof FormDataFieldDiscriminator.EmailField;
}

/** Empty */
/** @see {@link GuestValueDiscriminator.Empty} */
export interface Empty {
  /** @see {@link GuestValueDiscriminator.Empty} */
  type: typeof GuestValueDiscriminator.Empty;
}

/** EnvelopeIn */

export const EnvelopeInDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  BotEnvelope: "BotEnvelope",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LiveEnvelope: "LiveEnvelope",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemEnvelope: "SystemEnvelope",
} as const;
export type EnvelopeInDiscriminator = "BotEnvelope" | "LiveEnvelope" | "SystemEnvelope";

/** @see {@link EnvelopeInDiscriminator} */
export type EnvelopeIn =
  | ({
      type: "BotEnvelope";
    } & BotEnvelope)
  | ({
      type: "LiveEnvelope";
    } & LiveEnvelope)
  | ({
      type: "SystemEnvelope";
    } & SystemEnvelope);

/** EnvelopeOut */

export const EnvelopeOutDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  BotEnvelopeOut: "BotEnvelopeOut",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemEnvelopeOut: "SystemEnvelopeOut",
} as const;
export type EnvelopeOutDiscriminator = "BotEnvelopeOut" | "SystemEnvelopeOut";

/** @see {@link EnvelopeOutDiscriminator} */
export type EnvelopeOut =
  | ({
      type: "BotEnvelopeOut";
    } & BotEnvelopeOut)
  | ({
      type: "SystemEnvelopeOut";
    } & SystemEnvelopeOut);

/** Evaluable */

export const EvaluableDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RelativeDay: "RelativeDay",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RelativeMonth: "RelativeMonth",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RelativeQuarter: "RelativeQuarter",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RelativeWeek: "RelativeWeek",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RelativeYear: "RelativeYear",
} as const;
export type EvaluableDiscriminator =
  | "RelativeDay"
  | "RelativeMonth"
  | "RelativeQuarter"
  | "RelativeWeek"
  | "RelativeYear";

/** @see {@link EvaluableDiscriminator} */
export type Evaluable =
  | ({
      type: "RelativeDay";
    } & RelativeDay)
  | ({
      type: "RelativeMonth";
    } & RelativeMonth)
  | ({
      type: "RelativeQuarter";
    } & RelativeQuarter)
  | ({
      type: "RelativeWeek";
    } & RelativeWeek)
  | ({
      type: "RelativeYear";
    } & RelativeYear);

/** EvaluatedExistence */

export const EvaluatedExistenceDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AnyValueFound: "AnyValueFound",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  IdFound: "IdFound",
} as const;
export type EvaluatedExistenceDiscriminator = "AnyValueFound" | "IdFound";

/** @see {@link EvaluatedExistenceDiscriminator} */
export type EvaluatedExistence =
  | ({
      type: "AnyValueFound";
    } & AnyValueFound)
  | ({
      type: "IdFound";
    } & IdFound);

/** EvaluatedOwnership */

export const EvaluatedOwnershipDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  OwnerInTeam: "OwnerInTeam",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  OwnerNotInTeam: "OwnerNotInTeam",
} as const;
export type EvaluatedOwnershipDiscriminator = "OwnerInTeam" | "OwnerNotInTeam";

/** @see {@link EvaluatedOwnershipDiscriminator} */
export type EvaluatedOwnership =
  | ({
      type: "OwnerInTeam";
    } & OwnerInTeam1)
  | ({
      type: "OwnerNotInTeam";
    } & OwnerNotInTeam);

/** EvaluatedResult */

export const EvaluatedResultDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TimeRange: "TimeRange",
} as const;
export type EvaluatedResultDiscriminator = "TimeRange";

/** @see {@link EvaluatedResultDiscriminator} */
export type EvaluatedResult = {
  type: "TimeRange";
} & TimeRange;

/** EvaluatedValue */
/** @see {@link ValueSourceDiscriminator.EvaluatedValue} */
export interface EvaluatedValue {
  evaluable: Evaluable;
  evaluationTime?: OptionDateTime;
  /** @see {@link ValueSourceDiscriminator.EvaluatedValue} */
  type: typeof ValueSourceDiscriminator.EvaluatedValue;
}

/** EvaluatedValueLeaf */
/** @see {@link RuleEvaluationTreeDiscriminator.EvaluatedValueLeaf} */
export interface EvaluatedValueLeaf {
  conditionId: ConditionId;
  lhs?: OptionStaticValue;
  operator: Operator;
  rhs?: OptionEvaluatedResult;
  evaluatedTo: boolean;
  error?: OptionComparisonError;
  lhsValueSource: ValueSource;
  rhsValueSource: ValueSource;
  lhsExistenceValueSource?: OptionValueSource;
  /** @see {@link RuleEvaluationTreeDiscriminator.EvaluatedValueLeaf} */
  type: typeof RuleEvaluationTreeDiscriminator.EvaluatedValueLeaf;
}

/** EveryoneInTeam */
/** @see {@link ConversationAssignmentMethodDiscriminator.EveryoneInTeam} */
export interface EveryoneInTeam {
  /** @see {@link ConversationAssignmentMethodDiscriminator.EveryoneInTeam} */
  type: typeof ConversationAssignmentMethodDiscriminator.EveryoneInTeam;
}

/** EveryoneInTeamLiveChatRouting */
export interface EveryoneInTeamLiveChatRouting {
  onlineAssignees?: string[];
  offlineAssignees?: string[];
}

/** Exhausted */
/** @see {@link RepCandidacyDiscriminator.Exhausted} */
export interface Exhausted {
  /** @format date-time */
  startedAt: string;
  distributionId: DistributionId;
  /** @minItems 1 */
  triedCandidates: UserId[];
  markedDistributed?: boolean;
  /** @see {@link RepCandidacyDiscriminator.Exhausted} */
  type: typeof RepCandidacyDiscriminator.Exhausted;
}

/** ExistenceCheck */

export const ExistenceCheckDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  IdHasToExist: "IdHasToExist",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  IdOrAnyValueExists: "IdOrAnyValueExists",
} as const;
export type ExistenceCheckDiscriminator = "IdHasToExist" | "IdOrAnyValueExists";

/** @see {@link ExistenceCheckDiscriminator} */
export type ExistenceCheck =
  | ({
      type: "IdHasToExist";
    } & IdHasToExist)
  | ({
      type: "IdOrAnyValueExists";
    } & IdOrAnyValueExists);

/** ExistenceLeaf */
/** @see {@link RuleEvaluationTreeDiscriminator.ExistenceLeaf} */
export interface ExistenceLeaf {
  conditionId: ConditionId;
  exists: boolean;
  existenceCheck: ExistenceCheck;
  evaluatedExistence?: OptionEvaluatedExistence;
  evaluatedTo: boolean;
  valueSource?: OptionValueSource;
  /** @see {@link RuleEvaluationTreeDiscriminator.ExistenceLeaf} */
  type: typeof RuleEvaluationTreeDiscriminator.ExistenceLeaf;
}

/** Failed */
/** @see {@link CrmSyncStateDiscriminator.Failed} */
export interface Failed {
  /** @format date-time */
  failedAt: string;
  cause: string;
  prevState?: NonFailedState;
  /** @see {@link CrmSyncStateDiscriminator.Failed} */
  type: typeof CrmSyncStateDiscriminator.Failed;
}

/** Failure */
/** @see {@link NodeExecutionStatusLogDiscriminator.Failure} */
export interface Failure {
  title: string;
  reason: string;
  /** @format date-time */
  timestamp: string;
  /** @see {@link NodeExecutionStatusLogDiscriminator.Failure} */
  type: typeof NodeExecutionStatusLogDiscriminator.Failure;
}

/** FieldsSent */
export interface FieldsSent {
  fields: MapDataFieldRefString;
  /** @format date-time */
  timestamp: string;
}

/** FlexibleRoundRobin */
/** @see {@link ConversationAssignmentMethodDiscriminator.FlexibleRoundRobin} */
export interface FlexibleRoundRobin {
  /** @see {@link ConversationAssignmentMethodDiscriminator.FlexibleRoundRobin} */
  type: typeof ConversationAssignmentMethodDiscriminator.FlexibleRoundRobin;
}

/** FlexibleRoundRobin */
/** @see {@link MeetingAssignmentMethodDiscriminator.FlexibleRoundRobin} */
export interface FlexibleRoundRobin1 {
  /** @see {@link MeetingAssignmentMethodDiscriminator.FlexibleRoundRobin} */
  type: typeof MeetingAssignmentMethodDiscriminator.FlexibleRoundRobin;
}

/** FormData */
/** @see {@link ConversationInputDiscriminator.FormData} */
export interface FormData {
  values: MapDataFieldRefFormDataField;
  /** @see {@link ConversationInputDiscriminator.FormData} */
  type: typeof ConversationInputDiscriminator.FormData;
}

/** FormDataField */

export const FormDataFieldDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CheckboxField: "CheckboxField",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  EmailField: "EmailField",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LongTextField: "LongTextField",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NumberField: "NumberField",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PhoneField: "PhoneField",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PicklistField: "PicklistField",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RadioButtonField: "RadioButtonField",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ShortTextField: "ShortTextField",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TrueFalseField: "TrueFalseField",
} as const;
export type FormDataFieldDiscriminator =
  | "CheckboxField"
  | "EmailField"
  | "LongTextField"
  | "NumberField"
  | "PhoneField"
  | "PicklistField"
  | "RadioButtonField"
  | "ShortTextField"
  | "TrueFalseField";

/** @see {@link FormDataFieldDiscriminator} */
export type FormDataField =
  | ({
      type: "CheckboxField";
    } & CheckboxField)
  | ({
      type: "EmailField";
    } & EmailField)
  | ({
      type: "LongTextField";
    } & LongTextField)
  | ({
      type: "NumberField";
    } & NumberField)
  | ({
      type: "PhoneField";
    } & PhoneField)
  | ({
      type: "PicklistField";
    } & PicklistField)
  | ({
      type: "RadioButtonField";
    } & RadioButtonField)
  | ({
      type: "ShortTextField";
    } & ShortTextField)
  | ({
      type: "TrueFalseField";
    } & TrueFalseField);

/** FormDataValue */
/** @see {@link GuestValueDiscriminator.FormDataValue} */
export interface FormDataValue {
  value: FormDataField;
  /** @see {@link GuestValueDiscriminator.FormDataValue} */
  type: typeof GuestValueDiscriminator.FormDataValue;
}

/** FromInbox */
/** @see {@link ConversationAssignedSourceDiscriminator.FromInbox} */
export interface FromInbox {
  assigner: UserId;
  /** @see {@link ConversationAssignedSourceDiscriminator.FromInbox} */
  type: typeof ConversationAssignedSourceDiscriminator.FromInbox;
}

/** FromMeetingAssignment */
/** @see {@link ConversationAssignedSourceDiscriminator.FromMeetingAssignment} */
export interface FromMeetingAssignment {
  /** @see {@link ConversationAssignedSourceDiscriminator.FromMeetingAssignment} */
  type: typeof ConversationAssignedSourceDiscriminator.FromMeetingAssignment;
}

/** FromTeam */
/** @see {@link ConversationAssignedSourceDiscriminator.FromTeam} */
export interface FromTeam {
  teamId: TeamId;
  /** @see {@link ConversationAssignedSourceDiscriminator.FromTeam} */
  type: typeof ConversationAssignedSourceDiscriminator.FromTeam;
}

/** FrontendEventRequest */

export const FrontendEventRequestDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PageViewed: "PageViewed",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  WidgetClosed: "WidgetClosed",
} as const;
export type FrontendEventRequestDiscriminator = "PageViewed" | "WidgetClosed";

/** @see {@link FrontendEventRequestDiscriminator} */
export type FrontendEventRequest =
  | ({
      type: "PageViewed";
    } & PageViewed)
  | ({
      type: "WidgetClosed";
    } & WidgetClosed);

/** FuzzyOwnershipLeaf */
/** @see {@link RuleEvaluationTreeDiscriminator.FuzzyOwnershipLeaf} */
export interface FuzzyOwnershipLeaf {
  conditionId: ConditionId;
  matchedOwnerships?: ArrayOwnerInTeam;
  searchedBy: FuzzySearchOwnershipBy;
  evaluatedTo: boolean;
  error?: OptionComparisonError;
  value?: OptionStaticValue;
  valueSource: ValueSource;
  existenceValueSource?: OptionValueSource;
  /** @see {@link RuleEvaluationTreeDiscriminator.FuzzyOwnershipLeaf} */
  type: typeof RuleEvaluationTreeDiscriminator.FuzzyOwnershipLeaf;
}

/** FuzzySearchOwnershipBy */

export const FuzzySearchOwnershipBy = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TeamMemberFullNames: "TeamMemberFullNames",
} as const;
export type FuzzySearchOwnershipBy = "TeamMemberFullNames";

/** Giphy */
/** @see {@link MessagePartDiscriminator.Giphy} */
export interface Giphy {
  searchToken: string;
  /** @see {@link MessagePartDiscriminator.Giphy} */
  type: typeof MessagePartDiscriminator.Giphy;
}

/** GongLink */
/** @see {@link PickedMeetingLocationDiscriminator.GongLink} */
export interface GongLink {
  /** @see {@link PickedMeetingLocationDiscriminator.GongLink} */
  type: typeof PickedMeetingLocationDiscriminator.GongLink;
}

/** GuestMatch */

export const GuestMatchDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Account: "Account",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Contact: "Contact",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Lead: "Lead",
} as const;
export type GuestMatchDiscriminator = "Account" | "Contact" | "Lead";

/** @see {@link GuestMatchDiscriminator} */
export type GuestMatch =
  | ({
      type: "Account";
    } & Account)
  | ({
      type: "Contact";
    } & Contact)
  | ({
      type: "Lead";
    } & Lead);

/** GuestRerouted */
/** @see {@link TimelineEventDiscriminator.GuestRerouted} */
export interface GuestRerouted {
  /** @format date-time */
  created: string;
  users?: string[];
  totalTime: string;
  /** @see {@link TimelineEventDiscriminator.GuestRerouted} */
  type: typeof TimelineEventDiscriminator.GuestRerouted;
}

/** GuestSession */
/** @see {@link CallerRefDiscriminator.GuestSession} */
export interface GuestSession {
  id: GuestSessionId;
  /** @see {@link CallerRefDiscriminator.GuestSession} */
  type: typeof CallerRefDiscriminator.GuestSession;
}

/**
 * GuestSessionId
 * @pattern [^\s\\/]+
 */
export type GuestSessionId = string;

/** GuestStateRequestDto */
export interface GuestStateRequestDto {
  guestData: MapDataFieldRefGuestValue;
}

/** GuestStateResponseDto */
export interface GuestStateResponseDto {
  systemData?: SystemData;
  guestData?: MapDataFieldRefGuestValueWithMetadata;
  kickFireData?: KickFireData;
  crmSync?: CrmSyncWithNextUpdate;
}

/** GuestValue */

export const GuestValueDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DataFieldPicklistEntry: "DataFieldPicklistEntry",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DefaultFieldsValue: "DefaultFieldsValue",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Empty: "Empty",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FormDataValue: "FormDataValue",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemDataValue: "SystemDataValue",
} as const;
export type GuestValueDiscriminator =
  | "DataFieldPicklistEntry"
  | "DefaultFieldsValue"
  | "Empty"
  | "FormDataValue"
  | "SystemDataValue";

/** @see {@link GuestValueDiscriminator} */
export type GuestValue =
  | ({
      type: "DataFieldPicklistEntry";
    } & DataFieldPicklistEntry)
  | ({
      type: "DefaultFieldsValue";
    } & DefaultFieldsValue)
  | ({
      type: "Empty";
    } & Empty)
  | ({
      type: "FormDataValue";
    } & FormDataValue)
  | ({
      type: "SystemDataValue";
    } & SystemDataValue);

/** GuestValueWithMetadata */
export interface GuestValueWithMetadata {
  value: GuestValue;
  metadata: SimpleMetadata;
}

/** HostsDefaultConferenceDetails */
/** @see {@link PickedMeetingLocationDiscriminator.HostsDefaultConferenceDetails} */
export interface HostsDefaultConferenceDetails {
  /** @see {@link PickedMeetingLocationDiscriminator.HostsDefaultConferenceDetails} */
  type: typeof PickedMeetingLocationDiscriminator.HostsDefaultConferenceDetails;
}

/** HostsDefaultPhysicalLocation */
/** @see {@link PickedMeetingLocationDiscriminator.HostsDefaultPhysicalLocation} */
export interface HostsDefaultPhysicalLocation {
  /** @see {@link PickedMeetingLocationDiscriminator.HostsDefaultPhysicalLocation} */
  type: typeof PickedMeetingLocationDiscriminator.HostsDefaultPhysicalLocation;
}

/** IdFound */
/** @see {@link EvaluatedExistenceDiscriminator.IdFound} */
export interface IdFound {
  id: AnyDataObjectId;
  /** @see {@link EvaluatedExistenceDiscriminator.IdFound} */
  type: typeof EvaluatedExistenceDiscriminator.IdFound;
}

/** IdFromDataSource */
/** @see {@link ValueSourceDiscriminator.IdFromDataSource} */
export interface IdFromDataSource {
  ref: AliasedDataObjectReference;
  dataObjectId: AnyDataObjectId;
  /** @see {@link ValueSourceDiscriminator.IdFromDataSource} */
  type: typeof ValueSourceDiscriminator.IdFromDataSource;
}

/** IdHasToExist */
/** @see {@link ExistenceCheckDiscriminator.IdHasToExist} */
export interface IdHasToExist {
  reference: AliasedDataObjectReference;
  idField: DataField;
  /** @see {@link ExistenceCheckDiscriminator.IdHasToExist} */
  type: typeof ExistenceCheckDiscriminator.IdHasToExist;
}

/** IdOrAnyValueExists */
/** @see {@link ExistenceCheckDiscriminator.IdOrAnyValueExists} */
export interface IdOrAnyValueExists {
  reference: AliasedDataObjectReference;
  idField?: OptionDataField;
  /** @see {@link ExistenceCheckDiscriminator.IdOrAnyValueExists} */
  type: typeof ExistenceCheckDiscriminator.IdOrAnyValueExists;
}

/** Image */
/** @see {@link MessagePartDiscriminator.Image} */
export interface Image {
  url: string;
  /** @see {@link MessagePartDiscriminator.Image} */
  type: typeof MessagePartDiscriminator.Image;
}

/** InProgress */
/** @see {@link NodeExecutionStatusLogDiscriminator.InProgress} */
export interface InProgress {
  /** @see {@link NodeExecutionStatusLogDiscriminator.InProgress} */
  type: typeof NodeExecutionStatusLogDiscriminator.InProgress;
}

/** Inbox */
/** @see {@link ConversationAssignmentMethodDiscriminator.Inbox} */
export interface Inbox {
  /** @see {@link ConversationAssignmentMethodDiscriminator.Inbox} */
  type: typeof ConversationAssignmentMethodDiscriminator.Inbox;
}

/** InboxAssignee */
/** @see {@link AssigneeLogEntryDiscriminator.InboxAssignee} */
export interface InboxAssignee {
  id: UserId;
  /** @see {@link AssigneeLogEntryDiscriminator.InboxAssignee} */
  type: typeof AssigneeLogEntryDiscriminator.InboxAssignee;
}

/** InboxDescribeRoomResponseDto */
export interface InboxDescribeRoomResponseDto {
  /** @format uuid */
  guestId: string;
  workspaceId: WorkspaceId;
  /** @format uuid */
  playbookId: string;
}

/** InboxHandoff */
/** @see {@link MeetingAssignmentMethodDiscriminator.InboxHandoff} */
export interface InboxHandoff {
  /** @see {@link MeetingAssignmentMethodDiscriminator.InboxHandoff} */
  type: typeof MeetingAssignmentMethodDiscriminator.InboxHandoff;
}

/** InboxManagementRequestDto */

export const InboxManagementRequestDtoDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CloseAllRelatedInboxes: "CloseAllRelatedInboxes",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  OpenAllRelatedInboxes: "OpenAllRelatedInboxes",
} as const;
export type InboxManagementRequestDtoDiscriminator = "CloseAllRelatedInboxes" | "OpenAllRelatedInboxes";

/** @see {@link InboxManagementRequestDtoDiscriminator} */
export type InboxManagementRequestDto =
  | ({
      type: "CloseAllRelatedInboxes";
    } & CloseAllRelatedInboxes)
  | ({
      type: "OpenAllRelatedInboxes";
    } & OpenAllRelatedInboxes);

/** InboxReassignRequestDto */

export const InboxReassignRequestDtoDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ReassignToUser: "ReassignToUser",
} as const;
export type InboxReassignRequestDtoDiscriminator = "ReassignToUser";

/** @see {@link InboxReassignRequestDtoDiscriminator} */
export type InboxReassignRequestDto = {
  type: "ReassignToUser";
} & ReassignToUser;

/** Individual */
/** @see {@link SchedulingAssigneeDiscriminator.Individual} */
export interface Individual {
  assigneeId: UserId;
  /** @see {@link SchedulingAssigneeDiscriminator.Individual} */
  type: typeof SchedulingAssigneeDiscriminator.Individual;
}

/** Individual */
/** @see {@link LiveChatAssignmentDiscriminator.Individual} */
export interface Individual1 {
  assignee: UserId;
  /** @format date-time */
  waitForRepStartTime?: string;
  /** @format date-time */
  responseDeadline?: string;
  /** @see {@link LiveChatAssignmentDiscriminator.Individual} */
  type: typeof LiveChatAssignmentDiscriminator.Individual;
}

/** Individual */
/** @see {@link AnalyticsSchedulingAssigneeDiscriminator.Individual} */
export interface Individual2 {
  assigneeId: UserId;
  /** @see {@link AnalyticsSchedulingAssigneeDiscriminator.Individual} */
  type: typeof AnalyticsSchedulingAssigneeDiscriminator.Individual;
}

/** Individual */
/** @see {@link ConversationAssignmentMethodDiscriminator.Individual} */
export interface Individual3 {
  /** @see {@link ConversationAssignmentMethodDiscriminator.Individual} */
  type: typeof ConversationAssignmentMethodDiscriminator.Individual;
}

/** Individual */
/** @see {@link MeetingAssignmentMethodDiscriminator.Individual} */
export interface Individual4 {
  /** @see {@link MeetingAssignmentMethodDiscriminator.Individual} */
  type: typeof MeetingAssignmentMethodDiscriminator.Individual;
}

/** Individual */
export interface Individual5 {
  assigneeId: UserId;
}

/** IndividualLiveChatRouting */
export interface IndividualLiveChatRouting {
  assigneeId: UserId;
  online: boolean;
}

/** IndividualMeeting */
export interface IndividualMeeting {
  assigneeId: UserId;
}

/** Initialized */
/** @see {@link RepCandidacyDiscriminator.Initialized} */
export interface Initialized {
  /** @format date-time */
  startedAt: string;
  distributionId: DistributionId;
  markedDistributed?: boolean;
  /** @see {@link RepCandidacyDiscriminator.Initialized} */
  type: typeof RepCandidacyDiscriminator.Initialized;
}

/** Integration */
/** @see {@link CallerRefDiscriminator.Integration} */
export interface Integration {
  /** @pattern [^\s\\/]+ */
  id: string;
  /** @see {@link CallerRefDiscriminator.Integration} */
  type: typeof CallerRefDiscriminator.Integration;
}

/** InternalServerError */
/** @see {@link PayloadOutDiscriminator.InternalServerError} */
export interface InternalServerError {
  reason: string;
  /** @see {@link PayloadOutDiscriminator.InternalServerError} */
  type: typeof PayloadOutDiscriminator.InternalServerError;
}

/** InternalService */
/** @see {@link CallerRefDiscriminator.InternalService} */
export interface InternalService {
  /** @pattern [^\s\\/]+ */
  id: string;
  /** @see {@link CallerRefDiscriminator.InternalService} */
  type: typeof CallerRefDiscriminator.InternalService;
}

/** Job */
/** @see {@link CallerRefDiscriminator.Job} */
export interface Job {
  /** @pattern [^\s\\/]+ */
  id: string;
  /** @see {@link CallerRefDiscriminator.Job} */
  type: typeof CallerRefDiscriminator.Job;
}

/** KickFireCanadianProvince */

export const KickFireCanadianProvince = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Alberta: "Alberta",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  BritishColumbia: "British Columbia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NewBrunswick: "New Brunswick",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Newfoundland: "Newfoundland",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NovaScotia: "Nova Scotia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NorthwestTerritories: "Northwest Territories",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Nunavut: "Nunavut",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Ontario: "Ontario",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PrinceEdwardIsland: "Prince Edward Island",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Quebec: "Quebec",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Saskatchewan: "Saskatchewan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  YukonTerritory: "Yukon Territory",
} as const;
export type KickFireCanadianProvince =
  | "Alberta"
  | "British Columbia"
  | "New Brunswick"
  | "Newfoundland"
  | "Nova Scotia"
  | "Northwest Territories"
  | "Nunavut"
  | "Ontario"
  | "Prince Edward Island"
  | "Quebec"
  | "Saskatchewan"
  | "Yukon Territory";

/** KickFireCountry */

export const KickFireCountry = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Afghanistan: "Afghanistan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AlandIslands: "Aland Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Albania: "Albania",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Algeria: "Algeria",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AmericanSamoa: "American Samoa",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Andorra: "Andorra",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Angola: "Angola",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Anguilla: "Anguilla",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Antarctica: "Antarctica",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AntiguaAndBarbuda: "Antigua and Barbuda",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Argentina: "Argentina",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Armenia: "Armenia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Aruba: "Aruba",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AsiaPacificRegion: "Asia/Pacific Region",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Australia: "Australia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Austria: "Austria",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Azerbaijan: "Azerbaijan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Bahamas: "Bahamas",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Bahrain: "Bahrain",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Bangladesh: "Bangladesh",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Barbados: "Barbados",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Belarus: "Belarus",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Belgium: "Belgium",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Belize: "Belize",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Benin: "Benin",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Bermuda: "Bermuda",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Bhutan: "Bhutan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  BoliviaPlurinationalStateOf: "Bolivia (Plurinational State of)",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  BonaireSintEustatiusAndSaba: "Bonaire, Sint Eustatius and Saba",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  BosniaAndHerzegovina: "Bosnia and Herzegovina",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Botswana: "Botswana",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  BouvetIsland: "Bouvet Island",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Brazil: "Brazil",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  BritishIndianOceanTerritory: "British Indian Ocean Territory",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  BruneiDarussalam: "Brunei Darussalam",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Bulgaria: "Bulgaria",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  BurkinaFaso: "Burkina Faso",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Burundi: "Burundi",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CaboVerde: "Cabo Verde",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Cambodia: "Cambodia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Cameroon: "Cameroon",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Canada: "Canada",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CaymanIslands: "Cayman Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CentralAfricanRepublic: "Central African Republic",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Chad: "Chad",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Chile: "Chile",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  China: "China",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ChristmasIsland: "Christmas Island",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CocosKeelingIslands: "Cocos (Keeling) Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Colombia: "Colombia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Comoros: "Comoros",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Congo: "Congo",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CongoDemocraticRepublicOfThe: "Congo, Democratic Republic of the",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CookIslands: "Cook Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CostaRica: "Costa Rica",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CoteDIvoire: "Cote d Ivoire",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Croatia: "Croatia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Cuba: "Cuba",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Curacao: "Curacao",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Cyprus: "Cyprus",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Czechia: "Czechia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Denmark: "Denmark",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Djibouti: "Djibouti",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Dominica: "Dominica",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DominicanRepublic: "Dominican Republic",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Ecuador: "Ecuador",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Egypt: "Egypt",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ElSalvador: "El Salvador",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  EquatorialGuinea: "Equatorial Guinea",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Eritrea: "Eritrea",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Estonia: "Estonia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Eswatini: "Eswatini",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Ethiopia: "Ethiopia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FalklandIslandsMalvinas: "Falkland Islands (Malvinas)",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FaroeIslands: "Faroe Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Fiji: "Fiji",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Finland: "Finland",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  France: "France",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FrenchGuiana: "French Guiana",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FrenchPolynesia: "French Polynesia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FrenchSouthernTerritories: "French Southern Territories",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Gabon: "Gabon",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Gambia: "Gambia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Georgia: "Georgia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Germany: "Germany",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Ghana: "Ghana",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Gibraltar: "Gibraltar",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Greece: "Greece",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Greenland: "Greenland",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Grenada: "Grenada",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Guadeloupe: "Guadeloupe",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Guam: "Guam",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Guatemala: "Guatemala",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Guernsey: "Guernsey",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Guinea: "Guinea",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  GuineaBissau: "Guinea-Bissau",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Guyana: "Guyana",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Haiti: "Haiti",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  HeardIslandAndMcDonaldIslands: "Heard Island and McDonald Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  HolySee: "Holy See",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Honduras: "Honduras",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  HongKong: "Hong Kong",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Hungary: "Hungary",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Iceland: "Iceland",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  India: "India",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Indonesia: "Indonesia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  IranIslamicRepublicOf: "Iran (Islamic Republic of)",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Iraq: "Iraq",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Ireland: "Ireland",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  IsleOfMan: "Isle of Man",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Israel: "Israel",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Italy: "Italy",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Jamaica: "Jamaica",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Japan: "Japan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Jersey: "Jersey",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Jordan: "Jordan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Kazakhstan: "Kazakhstan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Kenya: "Kenya",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Kiribati: "Kiribati",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  KoreaDemocraticPeopleSRepublicOf: "Korea (Democratic People's Republic of)",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  KoreaRepublicOf: "Korea, Republic of",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Kuwait: "Kuwait",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Kyrgyzstan: "Kyrgyzstan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LaoPeopleSDemocraticRepublic: "Lao People's Democratic Republic",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Latvia: "Latvia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Lebanon: "Lebanon",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Lesotho: "Lesotho",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Liberia: "Liberia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Libya: "Libya",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Liechtenstein: "Liechtenstein",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Lithuania: "Lithuania",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Luxembourg: "Luxembourg",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Macao: "Macao",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Madagascar: "Madagascar",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Malawi: "Malawi",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Malaysia: "Malaysia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Maldives: "Maldives",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Mali: "Mali",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Malta: "Malta",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MarshallIslands: "Marshall Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Martinique: "Martinique",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Mauritania: "Mauritania",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Mauritius: "Mauritius",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Mayotte: "Mayotte",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Mexico: "Mexico",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MicronesiaFederatedStatesOf: "Micronesia (Federated States of)",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MoldovaRepublicOf: "Moldova, Republic of",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Monaco: "Monaco",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Mongolia: "Mongolia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Montenegro: "Montenegro",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Montserrat: "Montserrat",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Morocco: "Morocco",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Mozambique: "Mozambique",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Myanmar: "Myanmar",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Namibia: "Namibia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Nauru: "Nauru",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Nepal: "Nepal",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Netherlands: "Netherlands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NewCaledonia: "New Caledonia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NewZealand: "New Zealand",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Nicaragua: "Nicaragua",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Niger: "Niger",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Nigeria: "Nigeria",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Niue: "Niue",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NorfolkIsland: "Norfolk Island",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NorthMacedonia: "North Macedonia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NorthernMarianaIslands: "Northern Mariana Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Norway: "Norway",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Oman: "Oman",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Pakistan: "Pakistan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Palau: "Palau",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PalestineStateOf: "Palestine, State of",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Panama: "Panama",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PapuaNewGuinea: "Papua New Guinea",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Paraguay: "Paraguay",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Peru: "Peru",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Philippines: "Philippines",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Pitcairn: "Pitcairn",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Poland: "Poland",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Portugal: "Portugal",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PuertoRico: "Puerto Rico",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Qatar: "Qatar",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Reunion: "Reunion",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Romania: "Romania",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RussianFederation: "Russian Federation",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Rwanda: "Rwanda",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SaintBarthelemy: "Saint Barthelemy",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SaintHelenaAscensionAndTristanDaCunha: "Saint Helena, Ascension and Tristan da Cunha",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SaintKittsAndNevis: "Saint Kitts and Nevis",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SaintLucia: "Saint Lucia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SaintMartinFrenchPart: "Saint Martin (French part)",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SaintPierreAndMiquelon: "Saint Pierre and Miquelon",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SaintVincentAndTheGrenadines: "Saint Vincent and the Grenadines",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Samoa: "Samoa",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SanMarino: "San Marino",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SaoTomeAndPrincipe: "Sao Tome and Principe",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SaudiArabia: "Saudi Arabia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Senegal: "Senegal",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Serbia: "Serbia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Seychelles: "Seychelles",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SierraLeone: "Sierra Leone",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Singapore: "Singapore",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SintMaartenDutchPart: "Sint Maarten (Dutch part)",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Slovakia: "Slovakia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Slovenia: "Slovenia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SolomonIslands: "Solomon Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Somalia: "Somalia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SouthAfrica: "South Africa",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SouthGeorgiaAndTheSouthSandwichIslands: "South Georgia and the South Sandwich Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SouthSudan: "South Sudan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Spain: "Spain",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SriLanka: "Sri Lanka",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Sudan: "Sudan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Suriname: "Suriname",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SvalbardAndJanMayen: "Svalbard and Jan Mayen",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Sweden: "Sweden",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Switzerland: "Switzerland",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SyrianArabRepublic: "Syrian Arab Republic",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TaiwanProvinceOfChina: "Taiwan, Province of China",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Tajikistan: "Tajikistan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TanzaniaUnitedRepublicOf: "Tanzania, United Republic of",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Thailand: "Thailand",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TimorLeste: "Timor-Leste",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Togo: "Togo",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Tokelau: "Tokelau",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Tonga: "Tonga",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TrinidadAndTobago: "Trinidad and Tobago",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Tunisia: "Tunisia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Turkey: "Turkey",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Turkmenistan: "Turkmenistan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TurksAndCaicosIslands: "Turks and Caicos Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Tuvalu: "Tuvalu",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Uganda: "Uganda",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Ukraine: "Ukraine",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  UnitedArabEmirates: "United Arab Emirates",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  UnitedKingdom: "United Kingdom",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  UnitedStates: "United States",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  UnitedStatesMinorOutlyingIslands: "United States Minor Outlying Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Uruguay: "Uruguay",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Uzbekistan: "Uzbekistan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Vanuatu: "Vanuatu",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  VenezuelaBolivarianRepublicOf: "Venezuela (Bolivarian Republic of)",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  VietNam: "Viet Nam",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  VirginIslandsBritish: "Virgin Islands (British)",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  VirginIslandsUS: "Virgin Islands (U.S.)",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  WallisAndFutuna: "Wallis and Futuna",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  WesternSahara: "Western Sahara",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Yemen: "Yemen",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Zambia: "Zambia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Zimbabwe: "Zimbabwe",
} as const;
export type KickFireCountry =
  | "Afghanistan"
  | "Aland Islands"
  | "Albania"
  | "Algeria"
  | "American Samoa"
  | "Andorra"
  | "Angola"
  | "Anguilla"
  | "Antarctica"
  | "Antigua and Barbuda"
  | "Argentina"
  | "Armenia"
  | "Aruba"
  | "Asia/Pacific Region"
  | "Australia"
  | "Austria"
  | "Azerbaijan"
  | "Bahamas"
  | "Bahrain"
  | "Bangladesh"
  | "Barbados"
  | "Belarus"
  | "Belgium"
  | "Belize"
  | "Benin"
  | "Bermuda"
  | "Bhutan"
  | "Bolivia (Plurinational State of)"
  | "Bonaire, Sint Eustatius and Saba"
  | "Bosnia and Herzegovina"
  | "Botswana"
  | "Bouvet Island"
  | "Brazil"
  | "British Indian Ocean Territory"
  | "Brunei Darussalam"
  | "Bulgaria"
  | "Burkina Faso"
  | "Burundi"
  | "Cabo Verde"
  | "Cambodia"
  | "Cameroon"
  | "Canada"
  | "Cayman Islands"
  | "Central African Republic"
  | "Chad"
  | "Chile"
  | "China"
  | "Christmas Island"
  | "Cocos (Keeling) Islands"
  | "Colombia"
  | "Comoros"
  | "Congo"
  | "Congo, Democratic Republic of the"
  | "Cook Islands"
  | "Costa Rica"
  | "Cote d Ivoire"
  | "Croatia"
  | "Cuba"
  | "Curacao"
  | "Cyprus"
  | "Czechia"
  | "Denmark"
  | "Djibouti"
  | "Dominica"
  | "Dominican Republic"
  | "Ecuador"
  | "Egypt"
  | "El Salvador"
  | "Equatorial Guinea"
  | "Eritrea"
  | "Estonia"
  | "Eswatini"
  | "Ethiopia"
  | "Falkland Islands (Malvinas)"
  | "Faroe Islands"
  | "Fiji"
  | "Finland"
  | "France"
  | "French Guiana"
  | "French Polynesia"
  | "French Southern Territories"
  | "Gabon"
  | "Gambia"
  | "Georgia"
  | "Germany"
  | "Ghana"
  | "Gibraltar"
  | "Greece"
  | "Greenland"
  | "Grenada"
  | "Guadeloupe"
  | "Guam"
  | "Guatemala"
  | "Guernsey"
  | "Guinea"
  | "Guinea-Bissau"
  | "Guyana"
  | "Haiti"
  | "Heard Island and McDonald Islands"
  | "Holy See"
  | "Honduras"
  | "Hong Kong"
  | "Hungary"
  | "Iceland"
  | "India"
  | "Indonesia"
  | "Iran (Islamic Republic of)"
  | "Iraq"
  | "Ireland"
  | "Isle of Man"
  | "Israel"
  | "Italy"
  | "Jamaica"
  | "Japan"
  | "Jersey"
  | "Jordan"
  | "Kazakhstan"
  | "Kenya"
  | "Kiribati"
  | "Korea (Democratic People's Republic of)"
  | "Korea, Republic of"
  | "Kuwait"
  | "Kyrgyzstan"
  | "Lao People's Democratic Republic"
  | "Latvia"
  | "Lebanon"
  | "Lesotho"
  | "Liberia"
  | "Libya"
  | "Liechtenstein"
  | "Lithuania"
  | "Luxembourg"
  | "Macao"
  | "Madagascar"
  | "Malawi"
  | "Malaysia"
  | "Maldives"
  | "Mali"
  | "Malta"
  | "Marshall Islands"
  | "Martinique"
  | "Mauritania"
  | "Mauritius"
  | "Mayotte"
  | "Mexico"
  | "Micronesia (Federated States of)"
  | "Moldova, Republic of"
  | "Monaco"
  | "Mongolia"
  | "Montenegro"
  | "Montserrat"
  | "Morocco"
  | "Mozambique"
  | "Myanmar"
  | "Namibia"
  | "Nauru"
  | "Nepal"
  | "Netherlands"
  | "New Caledonia"
  | "New Zealand"
  | "Nicaragua"
  | "Niger"
  | "Nigeria"
  | "Niue"
  | "Norfolk Island"
  | "North Macedonia"
  | "Northern Mariana Islands"
  | "Norway"
  | "Oman"
  | "Pakistan"
  | "Palau"
  | "Palestine, State of"
  | "Panama"
  | "Papua New Guinea"
  | "Paraguay"
  | "Peru"
  | "Philippines"
  | "Pitcairn"
  | "Poland"
  | "Portugal"
  | "Puerto Rico"
  | "Qatar"
  | "Reunion"
  | "Romania"
  | "Russian Federation"
  | "Rwanda"
  | "Saint Barthelemy"
  | "Saint Helena, Ascension and Tristan da Cunha"
  | "Saint Kitts and Nevis"
  | "Saint Lucia"
  | "Saint Martin (French part)"
  | "Saint Pierre and Miquelon"
  | "Saint Vincent and the Grenadines"
  | "Samoa"
  | "San Marino"
  | "Sao Tome and Principe"
  | "Saudi Arabia"
  | "Senegal"
  | "Serbia"
  | "Seychelles"
  | "Sierra Leone"
  | "Singapore"
  | "Sint Maarten (Dutch part)"
  | "Slovakia"
  | "Slovenia"
  | "Solomon Islands"
  | "Somalia"
  | "South Africa"
  | "South Georgia and the South Sandwich Islands"
  | "South Sudan"
  | "Spain"
  | "Sri Lanka"
  | "Sudan"
  | "Suriname"
  | "Svalbard and Jan Mayen"
  | "Sweden"
  | "Switzerland"
  | "Syrian Arab Republic"
  | "Taiwan, Province of China"
  | "Tajikistan"
  | "Tanzania, United Republic of"
  | "Thailand"
  | "Timor-Leste"
  | "Togo"
  | "Tokelau"
  | "Tonga"
  | "Trinidad and Tobago"
  | "Tunisia"
  | "Turkey"
  | "Turkmenistan"
  | "Turks and Caicos Islands"
  | "Tuvalu"
  | "Uganda"
  | "Ukraine"
  | "United Arab Emirates"
  | "United Kingdom"
  | "United States"
  | "United States Minor Outlying Islands"
  | "Uruguay"
  | "Uzbekistan"
  | "Vanuatu"
  | "Venezuela (Bolivarian Republic of)"
  | "Viet Nam"
  | "Virgin Islands (British)"
  | "Virgin Islands (U.S.)"
  | "Wallis and Futuna"
  | "Western Sahara"
  | "Yemen"
  | "Zambia"
  | "Zimbabwe";

/** KickFireData */
export interface KickFireData {
  website: string;
  city: string;
  region: KickFireRegion;
  postal: string;
  country: KickFireCountry;
  companyName: string;
  employees: KickFireEmployees;
  revenue: KickFireRevenue;
  linkedIn: string;
}

/** KickFireEmployees */

export const KickFireEmployees = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value1To10: "1 to 10",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value10To50: "10 to 50",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value50To100: "50 to 100",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value100To250: "100 to 250",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value250To500: "250 to 500",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value500To1000: "500 to 1,000",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value1000To2500: "1,000 to 2,500",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value2500To5000: "2,500 to 5,000",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value5000To10000: "5,000 to 10,000",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value10000To25000: "10,000 to 25,000",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value25000: "25,000+",
} as const;
export type KickFireEmployees =
  | "1 to 10"
  | "10 to 50"
  | "50 to 100"
  | "100 to 250"
  | "250 to 500"
  | "500 to 1,000"
  | "1,000 to 2,500"
  | "2,500 to 5,000"
  | "5,000 to 10,000"
  | "10,000 to 25,000"
  | "25,000+";

/** KickFireRegion */

export const KickFireRegionDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  KickFireRegionCanadian: "KickFireRegionCanadian",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  KickFireRegionUs: "KickFireRegionUs",
} as const;
export type KickFireRegionDiscriminator = "KickFireRegionCanadian" | "KickFireRegionUs";

/** @see {@link KickFireRegionDiscriminator} */
export type KickFireRegion =
  | ({
      type: "KickFireRegionCanadian";
    } & KickFireRegionCanadian)
  | ({
      type: "KickFireRegionUs";
    } & KickFireRegionUs);

/** KickFireRegionCanadian */
/** @see {@link KickFireRegionDiscriminator.KickFireRegionCanadian} */
export interface KickFireRegionCanadian {
  value: KickFireCanadianProvince;
  /** @see {@link KickFireRegionDiscriminator.KickFireRegionCanadian} */
  type: typeof KickFireRegionDiscriminator.KickFireRegionCanadian;
}

/** KickFireRegionUs */
/** @see {@link KickFireRegionDiscriminator.KickFireRegionUs} */
export interface KickFireRegionUs {
  value: KickFireUsState;
  /** @see {@link KickFireRegionDiscriminator.KickFireRegionUs} */
  type: typeof KickFireRegionDiscriminator.KickFireRegionUs;
}

/** KickFireRevenue */

export const KickFireRevenue = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value1To1000000: "$1 to $1,000,000",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value1000000To5000000: "$1,000,000 to $5,000,000",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value5000000To10000000: "$5,000,000 to $10,000,000",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value10000000To50000000: "$10,000,000 to $50,000,000",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value50000000To100000000: "$50,000,000 to $100,000,000",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value100000000To250000000: "$100,000,000 to $250,000,000",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value250000000To500000000: "$250,000,000 to $500,000,000",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value500000000To1000000000: "$500,000,000 to $1,000,000,000",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Value1000000000: "$1,000,000,000+",
} as const;
export type KickFireRevenue =
  | "$1 to $1,000,000"
  | "$1,000,000 to $5,000,000"
  | "$5,000,000 to $10,000,000"
  | "$10,000,000 to $50,000,000"
  | "$50,000,000 to $100,000,000"
  | "$100,000,000 to $250,000,000"
  | "$250,000,000 to $500,000,000"
  | "$500,000,000 to $1,000,000,000"
  | "$1,000,000,000+";

/** KickFireUsState */

export const KickFireUsState = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ArmedForcesAmericas: "Armed Forces Americas",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ArmedForcesEuropeMiddleEastCanada: "Armed Forces Europe, Middle East, & Canada",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Alaska: "Alaska",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Alabama: "Alabama",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ArmedForcesPacific: "Armed Forces Pacific",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Arkansas: "Arkansas",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AmericanSamoa: "American Samoa",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Arizona: "Arizona",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  California: "California",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Colorado: "Colorado",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Connecticut: "Connecticut",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DistrictOfColumbia: "District of Columbia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Delaware: "Delaware",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Florida: "Florida",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FederatedStatesOfMicronesia: "Federated States of Micronesia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Georgia: "Georgia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Guam: "Guam",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Hawaii: "Hawaii",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Iowa: "Iowa",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Idaho: "Idaho",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Illinois: "Illinois",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Indiana: "Indiana",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Kansas: "Kansas",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Kentucky: "Kentucky",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Louisiana: "Louisiana",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Massachusetts: "Massachusetts",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Maryland: "Maryland",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Maine: "Maine",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MarshallIslands: "Marshall Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Michigan: "Michigan",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Minnesota: "Minnesota",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Missouri: "Missouri",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NorthernMarianaIslands: "Northern Mariana Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Mississippi: "Mississippi",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Montana: "Montana",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NorthCarolina: "North Carolina",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NorthDakota: "North Dakota",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Nebraska: "Nebraska",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NewHampshire: "New Hampshire",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NewJersey: "New Jersey",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NewMexico: "New Mexico",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Nevada: "Nevada",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NewYork: "New York",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Ohio: "Ohio",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Oklahoma: "Oklahoma",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Oregon: "Oregon",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Pennsylvania: "Pennsylvania",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Palau: "Palau",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RhodeIsland: "Rhode Island",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SouthCarolina: "South Carolina",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SouthDakota: "South Dakota",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Tennessee: "Tennessee",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Texas: "Texas",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Utah: "Utah",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Virginia: "Virginia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  VirginIslands: "Virgin Islands",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Vermont: "Vermont",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Washington: "Washington",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Wisconsin: "Wisconsin",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  WestVirginia: "West Virginia",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Wyoming: "Wyoming",
} as const;
export type KickFireUsState =
  | "Armed Forces Americas"
  | "Armed Forces Europe, Middle East, & Canada"
  | "Alaska"
  | "Alabama"
  | "Armed Forces Pacific"
  | "Arkansas"
  | "American Samoa"
  | "Arizona"
  | "California"
  | "Colorado"
  | "Connecticut"
  | "District of Columbia"
  | "Delaware"
  | "Florida"
  | "Federated States of Micronesia"
  | "Georgia"
  | "Guam"
  | "Hawaii"
  | "Iowa"
  | "Idaho"
  | "Illinois"
  | "Indiana"
  | "Kansas"
  | "Kentucky"
  | "Louisiana"
  | "Massachusetts"
  | "Maryland"
  | "Maine"
  | "Marshall Islands"
  | "Michigan"
  | "Minnesota"
  | "Missouri"
  | "Northern Mariana Islands"
  | "Mississippi"
  | "Montana"
  | "North Carolina"
  | "North Dakota"
  | "Nebraska"
  | "New Hampshire"
  | "New Jersey"
  | "New Mexico"
  | "Nevada"
  | "New York"
  | "Ohio"
  | "Oklahoma"
  | "Oregon"
  | "Pennsylvania"
  | "Palau"
  | "Rhode Island"
  | "South Carolina"
  | "South Dakota"
  | "Tennessee"
  | "Texas"
  | "Utah"
  | "Virginia"
  | "Virgin Islands"
  | "Vermont"
  | "Washington"
  | "Wisconsin"
  | "West Virginia"
  | "Wyoming";

/** KnownValue */
/** @see {@link ValueSourceDiscriminator.KnownValue} */
export interface KnownValue {
  dataObjectId?: OptionAnyDataObjectId;
  /** @see {@link ValueSourceDiscriminator.KnownValue} */
  type: typeof ValueSourceDiscriminator.KnownValue;
}

/** Last3Months */
/** @see {@link ReportingTimeframeDiscriminator.Last3Months} */
export interface Last3Months {
  /** @see {@link ReportingTimeframeDiscriminator.Last3Months} */
  type: typeof ReportingTimeframeDiscriminator.Last3Months;
}

/** LastMonth */
/** @see {@link ReportingTimeframeDiscriminator.LastMonth} */
export interface LastMonth {
  /** @see {@link ReportingTimeframeDiscriminator.LastMonth} */
  type: typeof ReportingTimeframeDiscriminator.LastMonth;
}

/** LastWeek */
/** @see {@link ReportingTimeframeDiscriminator.LastWeek} */
export interface LastWeek {
  /** @see {@link ReportingTimeframeDiscriminator.LastWeek} */
  type: typeof ReportingTimeframeDiscriminator.LastWeek;
}

/** Lead */
/** @see {@link GuestMatchDiscriminator.Lead} */
export interface Lead {
  id: CrmLeadId;
  /** @pattern [^\s\\/]+ */
  accountIdOpt?: string;
  /** @see {@link GuestMatchDiscriminator.Lead} */
  type: typeof GuestMatchDiscriminator.Lead;
}

/** LeadId */
/** @see {@link CrmIdDiscriminator.LeadId} */
export interface LeadId {
  value: string;
  /** @see {@link CrmIdDiscriminator.LeadId} */
  type: typeof CrmIdDiscriminator.LeadId;
}

/** LiveChat */
/** @see {@link SchedulingAssigneeDiscriminator.LiveChat} */
export interface LiveChat {
  /** @see {@link SchedulingAssigneeDiscriminator.LiveChat} */
  type: typeof SchedulingAssigneeDiscriminator.LiveChat;
}

/** LiveChat */
/** @see {@link AnalyticsSchedulingAssigneeDiscriminator.LiveChat} */
export interface LiveChat1 {
  /** @see {@link AnalyticsSchedulingAssigneeDiscriminator.LiveChat} */
  type: typeof AnalyticsSchedulingAssigneeDiscriminator.LiveChat;
}

/** LiveChatAssignee */
/** @see {@link AssigneeLogEntryDiscriminator.LiveChatAssignee} */
export interface LiveChatAssignee {
  id: UserId;
  /** @see {@link AssigneeLogEntryDiscriminator.LiveChatAssignee} */
  type: typeof AssigneeLogEntryDiscriminator.LiveChatAssignee;
}

/** LiveChatAssignment */

export const LiveChatAssignmentDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Individual: "Individual",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TeamFirstToInteract: "TeamFirstToInteract",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Unknown: "Unknown",
} as const;
export type LiveChatAssignmentDiscriminator = "Individual" | "TeamFirstToInteract" | "Unknown";

/** @see {@link LiveChatAssignmentDiscriminator} */
export type LiveChatAssignment =
  | ({
      type: "Individual";
    } & Individual1)
  | ({
      type: "TeamFirstToInteract";
    } & TeamFirstToInteract)
  | ({
      type: "Unknown";
    } & Unknown);

/** LiveChatReached */
/** @see {@link TimelineEventDiscriminator.LiveChatReached} */
export interface LiveChatReached {
  /** @format date-time */
  created: string;
  desiredUsers?: string[];
  /** @see {@link TimelineEventDiscriminator.LiveChatReached} */
  type: typeof TimelineEventDiscriminator.LiveChatReached;
}

/** LiveChatRouting */
export type LiveChatRouting =
  | EveryoneInTeamLiveChatRouting
  | IndividualLiveChatRouting
  | OwnerLiveChatRouting
  | TeamLiveChatRouting;

/** LiveEnvelope */
/** @see {@link EnvelopeInDiscriminator.LiveEnvelope} */
export interface LiveEnvelope {
  /** @see {@link EnvelopeInDiscriminator.LiveEnvelope} */
  type: typeof EnvelopeInDiscriminator.LiveEnvelope;
}

/** LocationConditionGroup */
/** @see {@link LocationConditionRequestDiscriminator.LocationConditionGroup} */
export interface LocationConditionGroup {
  /** @pattern [^\s\\/]+ */
  id: string;
  operator: LogicalOperator;
  /** @minItems 1 */
  conditions: LocationConditionRequest[];
  /** @see {@link LocationConditionRequestDiscriminator.LocationConditionGroup} */
  type: typeof LocationConditionRequestDiscriminator.LocationConditionGroup;
}

/** LocationConditionRequest */

export const LocationConditionRequestDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  BrowserLanguage: "BrowserLanguage",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DeviceType: "DeviceType",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LocationConditionGroup: "LocationConditionGroup",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PageValueCondition: "PageValueCondition",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  QueryValueCondition: "QueryValueCondition",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  UrlValueCondition: "UrlValueCondition",
} as const;
export type LocationConditionRequestDiscriminator =
  | "BrowserLanguage"
  | "DeviceType"
  | "LocationConditionGroup"
  | "PageValueCondition"
  | "QueryValueCondition"
  | "UrlValueCondition";

/** @see {@link LocationConditionRequestDiscriminator} */
export type LocationConditionRequest =
  | ({
      type: "BrowserLanguage";
    } & BrowserLanguage)
  | ({
      type: "DeviceType";
    } & DeviceType)
  | ({
      type: "LocationConditionGroup";
    } & LocationConditionGroup)
  | ({
      type: "PageValueCondition";
    } & PageValueCondition)
  | ({
      type: "QueryValueCondition";
    } & QueryValueCondition)
  | ({
      type: "UrlValueCondition";
    } & UrlValueCondition);

/** LocationSettings */

export const LocationSettingsDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ShowToEveryone: "ShowToEveryone",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ShowUnderConditions: "ShowUnderConditions",
} as const;
export type LocationSettingsDiscriminator = "ShowToEveryone" | "ShowUnderConditions";

/** @see {@link LocationSettingsDiscriminator} */
export type LocationSettings =
  | ({
      type: "ShowToEveryone";
    } & ShowToEveryone)
  | ({
      type: "ShowUnderConditions";
    } & ShowUnderConditions);

/** LocationSettingsResponseDto */
export interface LocationSettingsResponseDto {
  locationSettings: MapStringLocationSettings;
}

/** LogOpNode */
/** @see {@link RuleEvaluationTreeDiscriminator.LogOpNode} */
export interface LogOpNode {
  lhs: RuleEvaluationTree;
  op: LogicalOperator1;
  rhs: RuleEvaluationTree;
  evaluatedOwnership?: ArrayEvaluatedOwnership;
  evaluatedTo: boolean;
  /** @see {@link RuleEvaluationTreeDiscriminator.LogOpNode} */
  type: typeof RuleEvaluationTreeDiscriminator.LogOpNode;
}

/** LogicalOperator */

export const LogicalOperator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  And: "and",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Or: "or",
} as const;
export type LogicalOperator = "and" | "or";

/** LogicalOperator */

export const LogicalOperator1 = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  And: "and",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Or: "or",
} as const;
export type LogicalOperator1 = "and" | "or";

/** LongText */
/** @see {@link ChatDataFieldDataTypeDiscriminator.LongText} */
export interface LongText {
  /** @see {@link ChatDataFieldDataTypeDiscriminator.LongText} */
  type: typeof ChatDataFieldDataTypeDiscriminator.LongText;
}

/** LongTextField */
/** @see {@link FormDataFieldDiscriminator.LongTextField} */
export interface LongTextField {
  /** @pattern .{1,65000} */
  value: string;
  /** @see {@link FormDataFieldDiscriminator.LongTextField} */
  type: typeof FormDataFieldDiscriminator.LongTextField;
}

/** Map_DataFieldRef_FormDataField */
export type MapDataFieldRefFormDataField = Record<string, FormDataField>;

/** Map_DataFieldRef_GuestValue */
export type MapDataFieldRefGuestValue = Record<string, GuestValue>;

/** Map_DataFieldRef_GuestValueWithMetadata */
export type MapDataFieldRefGuestValueWithMetadata = Record<string, GuestValueWithMetadata>;

/** Map_DataFieldRef_String */
export type MapDataFieldRefString = Record<string, string>;

/** Map_DataField_StaticValue */
export type MapDataFieldStaticValue = Record<string, StaticValue>;

/** Map_DataObject_DataObjectValues */
export type MapDataObjectDataObjectValues = Record<string, DataObjectValues>;

/** Map_DataSource_Map_DataObject_DataObjectValues */
export type MapDataSourceMapDataObjectDataObjectValues = Record<string, MapDataObjectDataObjectValues>;

/** Map_OwnershipReference_Ownership */
export type MapOwnershipReferenceOwnership = Record<string, Ownership>;

/** Map_String */
export type MapString = Record<string, string>;

/** Map_String_GuestStateResponseDto */
export type MapStringGuestStateResponseDto = Record<string, GuestStateResponseDto>;

/** Map_String_LocationSettings */
export type MapStringLocationSettings = Record<string, LocationSettings>;

/** Map_String_String */
export type MapStringString = Record<string, string>;

/** Map_String_UserDescribeRoomResponseDto */
export type MapStringUserDescribeRoomResponseDto = Record<string, UserDescribeRoomResponseDto>;

/** Map_String_VisitedPagesLog */
export type MapStringVisitedPagesLog = Record<string, VisitedPagesLog>;

/** Map_UserId_Number */
export type MapUserIdNumber = Record<string, number>;

/** MatchedObject */

export const MatchedObject = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MatchedAccount: "MatchedAccount",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MatchedCase: "MatchedCase",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MatchedOpportunity: "MatchedOpportunity",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RelatedLead: "RelatedLead",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MatchedLead: "MatchedLead",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DuplicateLead: "DuplicateLead",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DuplicateContact: "DuplicateContact",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MatchedContact: "MatchedContact",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PrimaryOwner: "PrimaryOwner",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MatchedCompany: "MatchedCompany",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MatchedDeal: "MatchedDeal",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MatchedTicket: "MatchedTicket",
} as const;
export type MatchedObject =
  | "MatchedAccount"
  | "MatchedCase"
  | "MatchedOpportunity"
  | "RelatedLead"
  | "MatchedLead"
  | "DuplicateLead"
  | "DuplicateContact"
  | "MatchedContact"
  | "PrimaryOwner"
  | "MatchedCompany"
  | "MatchedDeal"
  | "MatchedTicket";

/** MaterializedData */
export interface MaterializedData {
  fields: MapDataSourceMapDataObjectDataObjectValues;
  ownerships: MapOwnershipReferenceOwnership;
}

/** Meeting */
export interface Meeting {
  assigneeId: UserId;
  origin: MeetingOrigin;
  /** @format date-time */
  scheduledAt: string;
}

/** MeetingAssignee */
/** @see {@link AssigneeLogEntryDiscriminator.MeetingAssignee} */
export interface MeetingAssignee {
  id: UserId;
  /** @pattern [^\s\\/]+ */
  distributionId?: string;
  routing?: RoutingLogEntry;
  /** @see {@link AssigneeLogEntryDiscriminator.MeetingAssignee} */
  type: typeof AssigneeLogEntryDiscriminator.MeetingAssignee;
}

/** MeetingAssignment */
export type MeetingAssignment = CrmOwnershipMeeting | IndividualMeeting | TeamMeeting;

/** MeetingAssignmentMethod */

export const MeetingAssignmentMethodDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CrmOwnership: "CrmOwnership",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FlexibleRoundRobin: "FlexibleRoundRobin",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  InboxHandoff: "InboxHandoff",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Individual: "Individual",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  StrictRoundRobin: "StrictRoundRobin",
} as const;
export type MeetingAssignmentMethodDiscriminator =
  | "CrmOwnership"
  | "FlexibleRoundRobin"
  | "InboxHandoff"
  | "Individual"
  | "StrictRoundRobin";

/** @see {@link MeetingAssignmentMethodDiscriminator} */
export type MeetingAssignmentMethod =
  | ({
      type: "CrmOwnership";
    } & CrmOwnership1)
  | ({
      type: "FlexibleRoundRobin";
    } & FlexibleRoundRobin1)
  | ({
      type: "InboxHandoff";
    } & InboxHandoff)
  | ({
      type: "Individual";
    } & Individual4)
  | ({
      type: "StrictRoundRobin";
    } & StrictRoundRobin1);

/** MeetingBookedSuccess */
/** @see {@link TimelineEventDiscriminator.MeetingBookedSuccess} */
export interface MeetingBookedSuccess {
  /** @format date-time */
  created: string;
  meetingId: MeetingId;
  /** @see {@link TimelineEventDiscriminator.MeetingBookedSuccess} */
  type: typeof TimelineEventDiscriminator.MeetingBookedSuccess;
}

/**
 * MeetingId
 * @format uuid
 */
export type MeetingId = string;

/** MeetingOrigin */

export const MeetingOrigin = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Journey: "Journey",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Inbox: "Inbox",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NoMeeting: "NoMeeting",
} as const;
export type MeetingOrigin = "Journey" | "Inbox" | "NoMeeting";

/** MeetingScheduled */
export interface MeetingScheduled {
  meetingId: MeetingId;
  assignment: MeetingAssignment;
  /** @format date-time */
  timestamp: string;
}

/** MeetingSchedulingFailed */
/** @see {@link PayloadOutDiscriminator.MeetingSchedulingFailed} */
export interface MeetingSchedulingFailed {
  errorCode: SchedulingErrorCode;
  /** @see {@link PayloadOutDiscriminator.MeetingSchedulingFailed} */
  type: typeof PayloadOutDiscriminator.MeetingSchedulingFailed;
}

/** MeetingSchedulingRequested */
/** @see {@link PayloadOutDiscriminator.MeetingSchedulingRequested} */
export interface MeetingSchedulingRequested {
  meetingId: MeetingId;
  /** @see {@link PayloadOutDiscriminator.MeetingSchedulingRequested} */
  type: typeof PayloadOutDiscriminator.MeetingSchedulingRequested;
}

/** MeetingSlotSelectedWithReservation */
/** @see {@link ConversationInputDiscriminator.MeetingSlotSelectedWithReservation} */
export interface MeetingSlotSelectedWithReservation {
  assigneeId: UserId;
  /** @format uuid */
  reservationId: string;
  interval: TimeInterval;
  pickedMeetingLocation: PickedMeetingLocation;
  timezone?: string;
  /** @pattern .+@.+ */
  email?: string;
  /** @see {@link ConversationInputDiscriminator.MeetingSlotSelectedWithReservation} */
  type: typeof ConversationInputDiscriminator.MeetingSlotSelectedWithReservation;
}

/** MeetingSlotSelectedWithoutReservation */
/** @see {@link ConversationInputDiscriminator.MeetingSlotSelectedWithoutReservation} */
export interface MeetingSlotSelectedWithoutReservation {
  /** @minItems 1 */
  assigneeIds: UserId[];
  interval: TimeInterval;
  pickedMeetingLocation: PickedMeetingLocation;
  timezone?: string;
  /** @pattern .+@.+ */
  email?: string;
  /** @see {@link ConversationInputDiscriminator.MeetingSlotSelectedWithoutReservation} */
  type: typeof ConversationInputDiscriminator.MeetingSlotSelectedWithoutReservation;
}

/** MeetingSlotSelectionCancelled */
/** @see {@link ConversationInputDiscriminator.MeetingSlotSelectionCancelled} */
export interface MeetingSlotSelectionCancelled {
  /** @see {@link ConversationInputDiscriminator.MeetingSlotSelectionCancelled} */
  type: typeof ConversationInputDiscriminator.MeetingSlotSelectionCancelled;
}

/** MeetingState */

export const MeetingStateDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Completed: "Completed",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Requested: "Requested",
} as const;
export type MeetingStateDiscriminator = "Completed" | "Requested";

/** @see {@link MeetingStateDiscriminator} */
export type MeetingState =
  | ({
      type: "Completed";
    } & Completed)
  | ({
      type: "Requested";
    } & Requested);

/** MeetingTimedOut */
export interface MeetingTimedOut {
  /** @format date-time */
  timestamp: string;
}

/**
 * MeetingTypeId
 * @format uuid
 */
export type MeetingTypeId = string;

/** MeetingTypeRef */
export interface MeetingTypeRef {
  id: MeetingTypeId;
}

/** MessagePart */

export const MessagePartDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Giphy: "Giphy",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Image: "Image",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Text: "Text",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Video: "Video",
} as const;
export type MessagePartDiscriminator = "Giphy" | "Image" | "Text" | "Video";

/** @see {@link MessagePartDiscriminator} */
export type MessagePart =
  | ({
      type: "Giphy";
    } & Giphy)
  | ({
      type: "Image";
    } & Image)
  | ({
      type: "Text";
    } & Text)
  | ({
      type: "Video";
    } & Video);

/** NavigateToLogDetails */
export interface NavigateToLogDetails {
  /** @format date-time */
  timestamp: string;
}

/** NextNode */
/** @see {@link NodeExitDiscriminator.NextNode} */
export interface NextNode {
  /** @format int64 */
  id: number;
  /** @see {@link NodeExitDiscriminator.NextNode} */
  type: typeof NodeExitDiscriminator.NextNode;
}

/** NoUserIsAvailable */
/** @see {@link TimelineEventDiscriminator.NoUserIsAvailable} */
export interface NoUserIsAvailable {
  /** @format date-time */
  created: string;
  /** @see {@link TimelineEventDiscriminator.NoUserIsAvailable} */
  type: typeof TimelineEventDiscriminator.NoUserIsAvailable;
}

/** NodeExecutionLog */
export interface NodeExecutionLog {
  /** @format uuid */
  nodeExecutionId: string;
  /** @format int64 */
  nodeId: number;
  details?: NodeExecutionLogDetails;
  status: NodeExecutionStatusLog;
  /** @format date-time */
  reachedAt: string;
}

/** NodeExecutionLogDetails */
export type NodeExecutionLogDetails =
  | AssignToLogDetails
  | NavigateToLogDetails
  | OfferMeetingLogDetails
  | RouteForLiveChatLogDetails
  | RoutingRuleLogDetails
  | SalesforceAddToCampaignLogDetails
  | SalesforceCreateEventLogDetails
  | SalesforceUpdateFieldLogDetails
  | SalesforceUpdateOwnershipLogDetails
  | SalesforceUpsertRecordLogDetails
  | SendDataFieldLogDetails
  | SendMessageLogDetails
  | SendReplyButtonsLogDetails
  | SendSlackNotificationLogDetails
  | WaitForRepLogDetails;

/** NodeExecutionResumed */
/** @see {@link ConversationInputDiscriminator.NodeExecutionResumed} */
export interface NodeExecutionResumed {
  /** @format int64 */
  nodeId: number;
  /** @see {@link ConversationInputDiscriminator.NodeExecutionResumed} */
  type: typeof ConversationInputDiscriminator.NodeExecutionResumed;
}

/** NodeExecutionStatusLog */

export const NodeExecutionStatusLogDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Failure: "Failure",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  InProgress: "InProgress",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NotImplemented: "NotImplemented",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Success: "Success",
} as const;
export type NodeExecutionStatusLogDiscriminator = "Failure" | "InProgress" | "NotImplemented" | "Success";

/** @see {@link NodeExecutionStatusLogDiscriminator} */
export type NodeExecutionStatusLog =
  | ({
      type: "Failure";
    } & Failure)
  | ({
      type: "InProgress";
    } & InProgress)
  | ({
      type: "NotImplemented";
    } & NotImplemented)
  | ({
      type: "Success";
    } & Success);

/** NodeExecutionTimedout */
/** @see {@link ConversationInputDiscriminator.NodeExecutionTimedout} */
export interface NodeExecutionTimedout {
  /** @format int64 */
  nodeId: number;
  /** @see {@link ConversationInputDiscriminator.NodeExecutionTimedout} */
  type: typeof ConversationInputDiscriminator.NodeExecutionTimedout;
}

/** NodeExit */

export const NodeExitDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NextNode: "NextNode",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Terminate: "Terminate",
} as const;
export type NodeExitDiscriminator = "NextNode" | "Terminate";

/** @see {@link NodeExitDiscriminator} */
export type NodeExit =
  | ({
      type: "NextNode";
    } & NextNode)
  | ({
      type: "Terminate";
    } & Terminate);

/** NodeReached */
/** @see {@link TimelineEventDiscriminator.NodeReached} */
export interface NodeReached {
  /** @format date-time */
  created: string;
  /** @format int64 */
  nodeId: number;
  /** @see {@link TimelineEventDiscriminator.NodeReached} */
  type: typeof TimelineEventDiscriminator.NodeReached;
}

/**
 * NonEmptyList_TinyTeamView
 * @minItems 1
 */
export type NonEmptyListTinyTeamView = TinyTeamView[];

/** NonFailedState */

export const NonFailedStateDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Completed: "Completed",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Delayed: "Delayed",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Requested: "Requested",
} as const;
export type NonFailedStateDiscriminator = "Completed" | "Delayed" | "Requested";

/** @see {@link NonFailedStateDiscriminator} */
export type NonFailedState =
  | ({
      type: "Completed";
    } & Completed1)
  | ({
      type: "Delayed";
    } & Delayed)
  | ({
      type: "Requested";
    } & Requested1);

/** NormalDataObject */
export type NormalDataObject = string;

/** NotImplemented */
/** @see {@link NodeExecutionStatusLogDiscriminator.NotImplemented} */
export interface NotImplemented {
  /** @see {@link NodeExecutionStatusLogDiscriminator.NotImplemented} */
  type: typeof NodeExecutionStatusLogDiscriminator.NotImplemented;
}

/** Number */
/** @see {@link ChatDataFieldDataTypeDiscriminator.Number} */
export interface Number {
  /** @see {@link ChatDataFieldDataTypeDiscriminator.Number} */
  type: typeof ChatDataFieldDataTypeDiscriminator.Number;
}

/** NumberField */
/** @see {@link FormDataFieldDiscriminator.NumberField} */
export interface NumberField {
  /** @format double */
  value: number;
  /** @see {@link FormDataFieldDiscriminator.NumberField} */
  type: typeof FormDataFieldDiscriminator.NumberField;
}

/** ObjectDoesNotExistAndCouldNotBeResolved */
/** @see {@link ComparisonErrorDiscriminator.ObjectDoesNotExistAndCouldNotBeResolved} */
export interface ObjectDoesNotExistAndCouldNotBeResolved {
  existenceContext: ObjectExistenceContext;
  /** @see {@link ComparisonErrorDiscriminator.ObjectDoesNotExistAndCouldNotBeResolved} */
  type: typeof ComparisonErrorDiscriminator.ObjectDoesNotExistAndCouldNotBeResolved;
}

/** ObjectExistenceContext */
export interface ObjectExistenceContext {
  baseObject: SimpleDataObject;
  topObject: SimpleDataObject;
  baseObjectCouldBeResolved: boolean;
  topObjectExists: boolean;
}

/** OfferMeetingLogDetails */
export interface OfferMeetingLogDetails {
  result?: OfferMeetingResult;
}

/** OfferMeetingResult */
export type OfferMeetingResult = MeetingScheduled | MeetingTimedOut;

/** OpenAllRelatedInboxes */
/** @see {@link InboxManagementRequestDtoDiscriminator.OpenAllRelatedInboxes} */
export interface OpenAllRelatedInboxes {
  /** @format uuid */
  guestId: string;
  /** @see {@link InboxManagementRequestDtoDiscriminator.OpenAllRelatedInboxes} */
  type: typeof InboxManagementRequestDtoDiscriminator.OpenAllRelatedInboxes;
}

/** Operator */

export const Operator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LessThan: "<",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  GreaterThan: ">",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LessThanOrEqualTo: "<=",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  GreaterThanOrEqualTo: ">=",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  StartsWithAnyOf: "startsWithAnyOf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  EndsWithAnyOf: "endsWithAnyOf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  IsAnyOf: "isAnyOf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  IsNotAnyOf: "isNotAnyOf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Equal: "equal",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NotEqual: "notEqual",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Contains: "contains",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DoesNotContain: "doesNotContain",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ContainsAnyOf: "containsAnyOf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ContainsNoneOf: "containsNoneOf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  StartsWith: "startsWith",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  EndsWith: "endsWith",
} as const;
export type Operator =
  | "<"
  | ">"
  | "<="
  | ">="
  | "startsWithAnyOf"
  | "endsWithAnyOf"
  | "isAnyOf"
  | "isNotAnyOf"
  | "equal"
  | "notEqual"
  | "contains"
  | "doesNotContain"
  | "containsAnyOf"
  | "containsNoneOf"
  | "startsWith"
  | "endsWith";

export type OptionAnyDataObjectId = AnyDataObjectId;

export type OptionComparisonError = ComparisonError;

export type OptionConditionId = ConditionId;

export type OptionDataField = DataField;

export type OptionDataReference = DataReference;

/**
 * Option_Date-time
 * @format date-time
 */
export type OptionDateTime = string;

export type OptionEmail = Email2;

export type OptionEvaluatedExistence = EvaluatedExistence;

export type OptionEvaluatedResult = EvaluatedResult;

export type OptionMaterializedData = MaterializedData;

export type OptionOwnershipReference = OwnershipReference;

export type OptionRevision = Revision;

export type OptionRuleEvaluationTree = RuleEvaluationTree;

export type OptionStaticValue = StaticValue;

/** Option_String */
export type OptionString = string;

export type OptionTeamId = TeamId1;

export type OptionUserId = UserId1;

export type OptionValueSource = ValueSource;

/** Owner */
/** @see {@link SchedulingAssigneeDiscriminator.Owner} */
export interface Owner {
  /** @see {@link SchedulingAssigneeDiscriminator.Owner} */
  type: typeof SchedulingAssigneeDiscriminator.Owner;
}

/** Owner */
/** @see {@link AnalyticsSchedulingAssigneeDiscriminator.Owner} */
export interface Owner1 {
  /** @see {@link AnalyticsSchedulingAssigneeDiscriminator.Owner} */
  type: typeof AnalyticsSchedulingAssigneeDiscriminator.Owner;
}

/** OwnerInTeam */
export interface OwnerInTeam {
  teamId: TeamId1;
  teams: NonEmptyListTinyTeamView;
  ownerId: UserId1;
  email?: OptionEmail;
  teamRevision: Revision;
  ownerName?: OptionString;
}

/** OwnerInTeam */
/** @see {@link EvaluatedOwnershipDiscriminator.OwnerInTeam} */
export interface OwnerInTeam1 {
  teamId: TeamId1;
  teams: NonEmptyListTinyTeamView;
  ownerId: UserId1;
  email?: OptionEmail;
  teamRevision: Revision;
  ownerName?: OptionString;
  /** @see {@link EvaluatedOwnershipDiscriminator.OwnerInTeam} */
  type: typeof EvaluatedOwnershipDiscriminator.OwnerInTeam;
}

/** OwnerLiveChatRouting */
export interface OwnerLiveChatRouting {
  assigneeId: UserId;
  online: boolean;
}

/** OwnerNotInTeam */
/** @see {@link EvaluatedOwnershipDiscriminator.OwnerNotInTeam} */
export interface OwnerNotInTeam {
  teamId?: OptionTeamId;
  ownerIdOpt?: OptionUserId;
  email?: OptionEmail;
  teamRevision?: OptionRevision;
  /** @see {@link EvaluatedOwnershipDiscriminator.OwnerNotInTeam} */
  type: typeof EvaluatedOwnershipDiscriminator.OwnerNotInTeam;
}

/** Ownership */
export interface Ownership {
  userId: UserId1;
  email?: OptionEmail;
}

/** OwnershipLeaf */
/** @see {@link RuleEvaluationTreeDiscriminator.OwnershipLeaf} */
export interface OwnershipLeaf {
  conditionId: ConditionId;
  evaluatedOwnership: EvaluatedOwnership;
  evaluatedTo: boolean;
  error?: OptionComparisonError;
  valueSource: ValueSource;
  existenceValueSource?: OptionValueSource;
  /** @see {@link RuleEvaluationTreeDiscriminator.OwnershipLeaf} */
  type: typeof RuleEvaluationTreeDiscriminator.OwnershipLeaf;
}

/** OwnershipReference */
export interface OwnershipReference {
  source: DataSource;
  object: DataObject;
  field: DataField;
}

/** OwnershipValueFromDataSource */
/** @see {@link ValueSourceDiscriminator.OwnershipValueFromDataSource} */
export interface OwnershipValueFromDataSource {
  ref: AliasedOwnershipReference;
  resolvedReference?: OptionOwnershipReference;
  /** @see {@link ValueSourceDiscriminator.OwnershipValueFromDataSource} */
  type: typeof ValueSourceDiscriminator.OwnershipValueFromDataSource;
}

/** PageBrowsed */
/** @see {@link TimelineEventDiscriminator.PageBrowsed} */
export interface PageBrowsed {
  /** @format date-time */
  created: string;
  url: string;
  /** @see {@link TimelineEventDiscriminator.PageBrowsed} */
  type: typeof TimelineEventDiscriminator.PageBrowsed;
}

/** PageOperator */

export const PageOperator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SymbolEqual: "=",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SymbolNotEqual: "!=",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LessThan: "<",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  GreaterThan: ">",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LessThanOrEqualTo: "<=",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  GreaterThanOrEqualTo: ">=",
} as const;
export type PageOperator = "=" | "!=" | "<" | ">" | "<=" | ">=";

/** PageScrollValue */
/** @see {@link StaticPageValueDiscriminator.PageScrollValue} */
export interface PageScrollValue {
  /** @format int32 */
  value: number;
  /** @see {@link StaticPageValueDiscriminator.PageScrollValue} */
  type: typeof StaticPageValueDiscriminator.PageScrollValue;
}

/** PageValueCondition */
/** @see {@link LocationConditionRequestDiscriminator.PageValueCondition} */
export interface PageValueCondition {
  /** @pattern [^\s\\/]+ */
  conditionId: string;
  operator: PageOperator;
  value: StaticPageValue;
  /** @see {@link LocationConditionRequestDiscriminator.PageValueCondition} */
  type: typeof LocationConditionRequestDiscriminator.PageValueCondition;
}

/** PageViewed */
/** @see {@link FrontendEventRequestDiscriminator.PageViewed} */
export interface PageViewed {
  url: string;
  /** @see {@link FrontendEventRequestDiscriminator.PageViewed} */
  type: typeof FrontendEventRequestDiscriminator.PageViewed;
}

/** PaginatedResult_SessionLogEntry */
export interface PaginatedResultSessionLogEntry {
  results?: SessionLogEntry[];
  /** @format int64 */
  total: number;
  /**
   * @format int64
   * @min 0
   */
  page: number;
  /**
   * @format int64
   * @exclusiveMin 0
   */
  pageSize: number;
}

/** Passive */
/** @see {@link DisplaySettingsDiscriminator.Passive} */
export interface Passive {
  /** @see {@link DisplaySettingsDiscriminator.Passive} */
  type: typeof DisplaySettingsDiscriminator.Passive;
}

/** PayloadOut */

export const PayloadOutDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ConversationData: "ConversationData",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ConversationSessionExpired: "ConversationSessionExpired",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DecodingFailure: "DecodingFailure",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  InternalServerError: "InternalServerError",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MeetingSchedulingFailed: "MeetingSchedulingFailed",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MeetingSchedulingRequested: "MeetingSchedulingRequested",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemConversationAssigned: "SystemConversationAssigned",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemConversationDeadline: "SystemConversationDeadline",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemConversationReassigned: "SystemConversationReassigned",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemConversationReassignedFromTeam: "SystemConversationReassignedFromTeam",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemMessage: "SystemMessage",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemRepsHaveFailedToRespond: "SystemRepsHaveFailedToRespond",
} as const;
export type PayloadOutDiscriminator =
  | "ConversationData"
  | "ConversationSessionExpired"
  | "DecodingFailure"
  | "InternalServerError"
  | "MeetingSchedulingFailed"
  | "MeetingSchedulingRequested"
  | "SystemConversationAssigned"
  | "SystemConversationDeadline"
  | "SystemConversationReassigned"
  | "SystemConversationReassignedFromTeam"
  | "SystemMessage"
  | "SystemRepsHaveFailedToRespond";

/** @see {@link PayloadOutDiscriminator} */
export type PayloadOut =
  | ({
      type: "ConversationData";
    } & ConversationData1)
  | ({
      type: "ConversationSessionExpired";
    } & ConversationSessionExpired)
  | ({
      type: "DecodingFailure";
    } & DecodingFailure)
  | ({
      type: "InternalServerError";
    } & InternalServerError)
  | ({
      type: "MeetingSchedulingFailed";
    } & MeetingSchedulingFailed)
  | ({
      type: "MeetingSchedulingRequested";
    } & MeetingSchedulingRequested)
  | ({
      type: "SystemConversationAssigned";
    } & SystemConversationAssigned)
  | ({
      type: "SystemConversationDeadline";
    } & SystemConversationDeadline)
  | ({
      type: "SystemConversationReassigned";
    } & SystemConversationReassigned)
  | ({
      type: "SystemConversationReassignedFromTeam";
    } & SystemConversationReassignedFromTeam)
  | ({
      type: "SystemMessage";
    } & SystemMessage)
  | ({
      type: "SystemRepsHaveFailedToRespond";
    } & SystemRepsHaveFailedToRespond);

/** Phone */
export type Phone = string;

/** Phone */
/** @see {@link ChatDataFieldDataTypeDiscriminator.Phone} */
export interface Phone1 {
  /** @see {@link ChatDataFieldDataTypeDiscriminator.Phone} */
  type: typeof ChatDataFieldDataTypeDiscriminator.Phone;
}

/** PhoneField */
/** @see {@link FormDataFieldDiscriminator.PhoneField} */
export interface PhoneField {
  value: Phone;
  /** @see {@link FormDataFieldDiscriminator.PhoneField} */
  type: typeof FormDataFieldDiscriminator.PhoneField;
}

/** PickedMeetingLocation */

export const PickedMeetingLocationDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AskTheGuest: "AskTheGuest",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  CalendarPlatformConference: "CalendarPlatformConference",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DefinedInMeetingType: "DefinedInMeetingType",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  GongLink: "GongLink",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  HostsDefaultConferenceDetails: "HostsDefaultConferenceDetails",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  HostsDefaultPhysicalLocation: "HostsDefaultPhysicalLocation",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RingCentralLink: "RingCentralLink",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ZoomOneTimeLink: "ZoomOneTimeLink",
} as const;
export type PickedMeetingLocationDiscriminator =
  | "AskTheGuest"
  | "CalendarPlatformConference"
  | "DefinedInMeetingType"
  | "GongLink"
  | "HostsDefaultConferenceDetails"
  | "HostsDefaultPhysicalLocation"
  | "RingCentralLink"
  | "ZoomOneTimeLink";

/** @see {@link PickedMeetingLocationDiscriminator} */
export type PickedMeetingLocation =
  | ({
      type: "AskTheGuest";
    } & AskTheGuest)
  | ({
      type: "CalendarPlatformConference";
    } & CalendarPlatformConference)
  | ({
      type: "DefinedInMeetingType";
    } & DefinedInMeetingType)
  | ({
      type: "GongLink";
    } & GongLink)
  | ({
      type: "HostsDefaultConferenceDetails";
    } & HostsDefaultConferenceDetails)
  | ({
      type: "HostsDefaultPhysicalLocation";
    } & HostsDefaultPhysicalLocation)
  | ({
      type: "RingCentralLink";
    } & RingCentralLink)
  | ({
      type: "ZoomOneTimeLink";
    } & ZoomOneTimeLink);

/** Picklist */
/** @see {@link ChatDataFieldDataTypeDiscriminator.Picklist} */
export interface Picklist {
  /** @minItems 1 */
  values: string[];
  /** @see {@link ChatDataFieldDataTypeDiscriminator.Picklist} */
  type: typeof ChatDataFieldDataTypeDiscriminator.Picklist;
}

/** PicklistField */
/** @see {@link FormDataFieldDiscriminator.PicklistField} */
export interface PicklistField {
  value: string;
  /** @see {@link FormDataFieldDiscriminator.PicklistField} */
  type: typeof FormDataFieldDiscriminator.PicklistField;
}

/** PlaybookInteractedWith */
/** @see {@link TimelineEventDiscriminator.PlaybookInteractedWith} */
export interface PlaybookInteractedWith {
  /** @format date-time */
  created: string;
  /** @see {@link TimelineEventDiscriminator.PlaybookInteractedWith} */
  type: typeof TimelineEventDiscriminator.PlaybookInteractedWith;
}

/** PlaybookLaunched */
/** @see {@link TimelineEventDiscriminator.PlaybookLaunched} */
export interface PlaybookLaunched {
  /** @format date-time */
  created: string;
  /** @see {@link TimelineEventDiscriminator.PlaybookLaunched} */
  type: typeof TimelineEventDiscriminator.PlaybookLaunched;
}

/** PlaybookStatsRequest */
export interface PlaybookStatsRequest {
  playbookFilter: ReportingPlaybookFilter;
  timeframe: ReportingTimeframe;
}

/** PlaybookStatsResponse */
export interface PlaybookStatsResponse {
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
  /** @format int64 */
  triggered: number;
  /** @format int64 */
  launched: number;
  /** @format int64 */
  interacted: number;
  /** @format int64 */
  reachedLiveChat: number;
  /** @format int64 */
  liveChatNooneAvailable: number;
  /** @format int64 */
  liveChatNoEngagement: number;
  /** @format int64 */
  liveChatJoined: number;
  /** @format int64 */
  reachedBookMeeting: number;
  /** @format int64 */
  bookedMeetingsInbox: number;
  /** @format int64 */
  bookedMeetingsBot: number;
  /** @format int64 */
  salesforceLeadsCreated: number;
  /** @format int64 */
  salesforceLeadsUpdated: number;
  /** @format int64 */
  salesforceContactsCreated: number;
  /** @format int64 */
  salesforceContactsUpdated: number;
  /** @format double */
  averageTimeToReachLiveChatOrBookMeetingNodeSecs?: number;
  /** @format double */
  averageLivechatResponseTimeSecs?: number;
  /** @format double */
  averageBookMeetingWaitTimeSecs?: number;
  /** @format int64 */
  reassignedTimes: number;
}

/** PlaybookTriggered */
/** @see {@link TimelineEventDiscriminator.PlaybookTriggered} */
export interface PlaybookTriggered {
  /** @format date-time */
  created: string;
  /** @see {@link TimelineEventDiscriminator.PlaybookTriggered} */
  type: typeof TimelineEventDiscriminator.PlaybookTriggered;
}

/** PrepareChatRequestDto */
export interface PrepareChatRequestDto {
  /** @format uuid */
  guestId: string;
}

/** PrepareChatResponseDto */
export interface PrepareChatResponseDto {
  roomJid: string;
  guestJid: string;
  /** Value of Authorization header */
  authorizationHeader: string;
  refreshToken?: string;
}

/** PrivateAndTenantUsers */
export interface PrivateAndTenantUsers {
  userJid: string;
  /** Value of Authorization header */
  authorizationHeader: string;
  refreshToken?: string;
  publicUserJid: string;
  /** Value of Authorization header */
  publicAuthorizationHeader: string;
  publicRefreshToken?: string;
}

/** PrivateAndWorkspaceUsers */
export interface PrivateAndWorkspaceUsers {
  userJid: string;
  /** Value of Authorization header */
  authorizationHeader: string;
  refreshToken?: string;
  publicUserJid: string;
  /** Value of Authorization header */
  publicAuthorizationHeader: string;
  publicRefreshToken?: string;
}

/** Pushy */
/** @see {@link DisplaySettingsDiscriminator.Pushy} */
export interface Pushy {
  /** @see {@link DisplaySettingsDiscriminator.Pushy} */
  type: typeof DisplaySettingsDiscriminator.Pushy;
}

/** QueryOperator */

export const QueryOperator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SymbolEqual: "=",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SymbolNotEqual: "!=",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Contains: "contains",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DoesNotContain: "doesNotContain",
} as const;
export type QueryOperator = "=" | "!=" | "contains" | "doesNotContain";

/** QueryParamsValue */
export interface QueryParamsValue {
  value: string;
}

/** QueryValueCondition */
/** @see {@link LocationConditionRequestDiscriminator.QueryValueCondition} */
export interface QueryValueCondition {
  /** @pattern [^\s\\/]+ */
  conditionId: string;
  operator: QueryOperator;
  value: QueryParamsValue;
  /** @see {@link LocationConditionRequestDiscriminator.QueryValueCondition} */
  type: typeof LocationConditionRequestDiscriminator.QueryValueCondition;
}

/** RadioButton */
/** @see {@link ChatDataFieldDataTypeDiscriminator.RadioButton} */
export interface RadioButton {
  /** @minItems 1 */
  values: string[];
  /** @see {@link ChatDataFieldDataTypeDiscriminator.RadioButton} */
  type: typeof ChatDataFieldDataTypeDiscriminator.RadioButton;
}

/** RadioButtonField */
/** @see {@link FormDataFieldDiscriminator.RadioButtonField} */
export interface RadioButtonField {
  value: string;
  /** @see {@link FormDataFieldDiscriminator.RadioButtonField} */
  type: typeof FormDataFieldDiscriminator.RadioButtonField;
}

/** ReassignToUser */
/** @see {@link InboxReassignRequestDtoDiscriminator.ReassignToUser} */
export interface ReassignToUser {
  /** @format uuid */
  guestId: string;
  toUser: UserId;
  /** @see {@link InboxReassignRequestDtoDiscriminator.ReassignToUser} */
  type: typeof InboxReassignRequestDtoDiscriminator.ReassignToUser;
}

/** Reassigned */
/** @see {@link TimelineEventDiscriminator.Reassigned} */
export interface Reassigned {
  /** @format date-time */
  created: string;
  by: UserId;
  from: LiveChatAssignment;
  to: LiveChatAssignment;
  /** @see {@link TimelineEventDiscriminator.Reassigned} */
  type: typeof TimelineEventDiscriminator.Reassigned;
}

/** ReceivedEmail */
/** @see {@link TimelineEventDiscriminator.ReceivedEmail} */
export interface ReceivedEmail {
  /** @format date-time */
  created: string;
  email: Email;
  /** @see {@link TimelineEventDiscriminator.ReceivedEmail} */
  type: typeof TimelineEventDiscriminator.ReceivedEmail;
}

/**
 * RelatedChildObjectRef
 * @pattern [a-zA-Z0-9_]+__rc
 */
export type RelatedChildObjectRef = string;

/** RelatedDataObject_SimpleDataObject */
export interface RelatedDataObjectSimpleDataObject {
  topObject: SimpleDataObject;
  relations: Relation;
}

/** RelatedSession */
export interface RelatedSession {
  /**
   * @format int32
   * @exclusiveMin 0
   */
  sessionNum: number;
  /** @format uuid */
  playbookId: string;
  /** @format date-time */
  triggeredAt: string;
  /** @format int32 */
  errors: number;
}

/**
 * Relation
 * @minItems 1
 */
export type Relation = SimpleDataObject[];

/** RelativeDay */
/** @see {@link EvaluableDiscriminator.RelativeDay} */
export interface RelativeDay {
  /** @format int32 */
  offset: number;
  /**
   * @format int32
   * @exclusiveMin 0
   */
  length: number;
  timeZone?: OptionString;
  /** @see {@link EvaluableDiscriminator.RelativeDay} */
  type: typeof EvaluableDiscriminator.RelativeDay;
}

/** RelativeMonth */
/** @see {@link EvaluableDiscriminator.RelativeMonth} */
export interface RelativeMonth {
  /** @format int32 */
  offset: number;
  /**
   * @format int32
   * @exclusiveMin 0
   */
  length: number;
  timeZone?: OptionString;
  /** @see {@link EvaluableDiscriminator.RelativeMonth} */
  type: typeof EvaluableDiscriminator.RelativeMonth;
}

/** RelativeQuarter */
/** @see {@link EvaluableDiscriminator.RelativeQuarter} */
export interface RelativeQuarter {
  /** @format int32 */
  offset: number;
  /**
   * @format int32
   * @exclusiveMin 0
   */
  length: number;
  timeZone?: OptionString;
  /** @see {@link EvaluableDiscriminator.RelativeQuarter} */
  type: typeof EvaluableDiscriminator.RelativeQuarter;
}

/** RelativeWeek */
/** @see {@link EvaluableDiscriminator.RelativeWeek} */
export interface RelativeWeek {
  /** @format int32 */
  offset: number;
  /**
   * @format int32
   * @exclusiveMin 0
   */
  length: number;
  timeZone?: OptionString;
  /** @see {@link EvaluableDiscriminator.RelativeWeek} */
  type: typeof EvaluableDiscriminator.RelativeWeek;
}

/** RelativeYear */
/** @see {@link EvaluableDiscriminator.RelativeYear} */
export interface RelativeYear {
  /** @format int32 */
  offset: number;
  /**
   * @format int32
   * @exclusiveMin 0
   */
  length: number;
  timeZone?: OptionString;
  /** @see {@link EvaluableDiscriminator.RelativeYear} */
  type: typeof EvaluableDiscriminator.RelativeYear;
}

/** RepCandidacy */

export const RepCandidacyDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Exhausted: "Exhausted",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Initialized: "Initialized",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RoundRobin: "RoundRobin",
} as const;
export type RepCandidacyDiscriminator = "Exhausted" | "Initialized" | "RoundRobin";

/** @see {@link RepCandidacyDiscriminator} */
export type RepCandidacy =
  | ({
      type: "Exhausted";
    } & Exhausted)
  | ({
      type: "Initialized";
    } & Initialized)
  | ({
      type: "RoundRobin";
    } & RoundRobin);

/** RepFailedToEngage */
/** @see {@link TimelineEventDiscriminator.RepFailedToEngage} */
export interface RepFailedToEngage {
  /** @format date-time */
  created: string;
  users?: string[];
  /** @see {@link TimelineEventDiscriminator.RepFailedToEngage} */
  type: typeof TimelineEventDiscriminator.RepFailedToEngage;
}

/** RepJoinOrTimeoutAction */
/** @see {@link ConversationActionDiscriminator.RepJoinOrTimeoutAction} */
export interface RepJoinOrTimeoutAction {
  /** @see {@link ConversationActionDiscriminator.RepJoinOrTimeoutAction} */
  type: typeof ConversationActionDiscriminator.RepJoinOrTimeoutAction;
}

/** RepJoined */
export interface RepJoined {
  duration: string;
}

/** RepNotJoined */
export type RepNotJoined = object;

/** RepSentMessage */
/** @see {@link ConversationInputDiscriminator.RepSentMessage} */
export interface RepSentMessage {
  rep: UserId;
  /** @see {@link ConversationInputDiscriminator.RepSentMessage} */
  type: typeof ConversationInputDiscriminator.RepSentMessage;
}

/** ReplyButton */
export interface ReplyButton {
  text: string;
  target: NodeExit;
}

/** ReplyButtonSelected */
/** @see {@link ConversationInputDiscriminator.ReplyButtonSelected} */
export interface ReplyButtonSelected {
  /** @format int32 */
  index: number;
  /** @see {@link ConversationInputDiscriminator.ReplyButtonSelected} */
  type: typeof ConversationInputDiscriminator.ReplyButtonSelected;
}

/** ReportingPlaybookFilter */

export const ReportingPlaybookFilterDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  All: "All",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Several: "Several",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Single: "Single",
} as const;
export type ReportingPlaybookFilterDiscriminator = "All" | "Several" | "Single";

/** @see {@link ReportingPlaybookFilterDiscriminator} */
export type ReportingPlaybookFilter =
  | ({
      type: "All";
    } & All)
  | ({
      type: "Several";
    } & Several)
  | ({
      type: "Single";
    } & Single);

/** ReportingTimeframe */

export const ReportingTimeframeDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Custom: "Custom",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Last3Months: "Last3Months",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LastMonth: "LastMonth",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LastWeek: "LastWeek",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ThisMonth: "ThisMonth",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ThisWeek: "ThisWeek",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ThisYear: "ThisYear",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Today: "Today",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Yesterday: "Yesterday",
} as const;
export type ReportingTimeframeDiscriminator =
  | "Custom"
  | "Last3Months"
  | "LastMonth"
  | "LastWeek"
  | "ThisMonth"
  | "ThisWeek"
  | "ThisYear"
  | "Today"
  | "Yesterday";

/** @see {@link ReportingTimeframeDiscriminator} */
export type ReportingTimeframe =
  | ({
      type: "Custom";
    } & Custom)
  | ({
      type: "Last3Months";
    } & Last3Months)
  | ({
      type: "LastMonth";
    } & LastMonth)
  | ({
      type: "LastWeek";
    } & LastWeek)
  | ({
      type: "ThisMonth";
    } & ThisMonth)
  | ({
      type: "ThisWeek";
    } & ThisWeek)
  | ({
      type: "ThisYear";
    } & ThisYear)
  | ({
      type: "Today";
    } & Today)
  | ({
      type: "Yesterday";
    } & Yesterday);

/** ReportingTimeline */
export interface ReportingTimeline {
  /** @format uuid */
  guestId: string;
  /** @format uuid */
  playbookId: string;
  /** @format int32 */
  playbookVersion: number;
  workspaceId: WorkspaceId;
  events?: TimelineEvent[];
}

/** ReportingUserFilter */

export const ReportingUserFilterDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  All: "All",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Several: "Several",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Single: "Single",
} as const;
export type ReportingUserFilterDiscriminator = "All" | "Several" | "Single";

/** @see {@link ReportingUserFilterDiscriminator} */
export type ReportingUserFilter =
  | ({
      type: "All";
    } & All1)
  | ({
      type: "Several";
    } & Several1)
  | ({
      type: "Single";
    } & Single1);

/** Requested */
/** @see {@link MeetingStateDiscriminator.Requested} */
export interface Requested {
  meetingId: MeetingId;
  /** @see {@link MeetingStateDiscriminator.Requested} */
  type: typeof MeetingStateDiscriminator.Requested;
}

/** Requested */
/** @see {@link NonFailedStateDiscriminator.Requested} */
export interface Requested1 {
  /** @format date-time */
  requestedAt: string;
  mostRecentData?: CrmData;
  nextSyncRequired: boolean;
  /** @see {@link NonFailedStateDiscriminator.Requested} */
  type: typeof NonFailedStateDiscriminator.Requested;
}

/** ResumeNodeExecution */
/** @see {@link ConversationActionDiscriminator.ResumeNodeExecution} */
export interface ResumeNodeExecution {
  /** @see {@link ConversationActionDiscriminator.ResumeNodeExecution} */
  type: typeof ConversationActionDiscriminator.ResumeNodeExecution;
}

/**
 * Revision
 * @format int32
 */
export type Revision = number;

/** RingCentralLink */
/** @see {@link PickedMeetingLocationDiscriminator.RingCentralLink} */
export interface RingCentralLink {
  /** @see {@link PickedMeetingLocationDiscriminator.RingCentralLink} */
  type: typeof PickedMeetingLocationDiscriminator.RingCentralLink;
}

/** RoundRobin */
/** @see {@link RepCandidacyDiscriminator.RoundRobin} */
export interface RoundRobin {
  /** @format date-time */
  startedAt: string;
  /** @minItems 1 */
  lockedCandidates: UserId[];
  /** @minItems 1 */
  triedCandidates: UserId[];
  /**
   * @format int32
   * @exclusiveMin 0
   */
  attemptsLeft: number;
  distributionId: DistributionId;
  markedDistributed?: boolean;
  /** @see {@link RepCandidacyDiscriminator.RoundRobin} */
  type: typeof RepCandidacyDiscriminator.RoundRobin;
}

/** RoundRobinKind */

export const RoundRobinKind = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AvailabilityOptimised: "AvailabilityOptimised",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Strict: "Strict",
} as const;
export type RoundRobinKind = "AvailabilityOptimised" | "Strict";

/** RouteForLiveChatLogDetails */
export interface RouteForLiveChatLogDetails {
  routing: LiveChatRouting;
  /** @format date-time */
  timestamp: string;
}

/** RoutingLogEntry */

export const RoutingLogEntryDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RuleApplied: "RuleApplied",
} as const;
export type RoutingLogEntryDiscriminator = "RuleApplied";

/** @see {@link RoutingLogEntryDiscriminator} */
export type RoutingLogEntry = {
  type: "RuleApplied";
} & RuleApplied;

/** RoutingRuleLogDetails */
export interface RoutingRuleLogDetails {
  result: RuleExecutionResult;
  /** @format date-time */
  timestamp: string;
}

/** RuleApplied */
/** @see {@link RoutingLogEntryDiscriminator.RuleApplied} */
export interface RuleApplied {
  ruleId: RuleId;
  /** @pattern [^\s\\/]+ */
  ownerTeamId?: string;
  /** @see {@link RoutingLogEntryDiscriminator.RuleApplied} */
  type: typeof RoutingLogEntryDiscriminator.RuleApplied;
}

/** RuleEvaluationTree */

export const RuleEvaluationTreeDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AlwaysTrueLeaf: "AlwaysTrueLeaf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  EvaluatedValueLeaf: "EvaluatedValueLeaf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ExistenceLeaf: "ExistenceLeaf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  FuzzyOwnershipLeaf: "FuzzyOwnershipLeaf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LogOpNode: "LogOpNode",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  OwnershipLeaf: "OwnershipLeaf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SingleParameterLeaf: "SingleParameterLeaf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  StaticParameterLeaf: "StaticParameterLeaf",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TwoStaticParametersLeaf: "TwoStaticParametersLeaf",
} as const;
export type RuleEvaluationTreeDiscriminator =
  | "AlwaysTrueLeaf"
  | "EvaluatedValueLeaf"
  | "ExistenceLeaf"
  | "FuzzyOwnershipLeaf"
  | "LogOpNode"
  | "OwnershipLeaf"
  | "SingleParameterLeaf"
  | "StaticParameterLeaf"
  | "TwoStaticParametersLeaf";

/** @see {@link RuleEvaluationTreeDiscriminator} */
export type RuleEvaluationTree =
  | ({
      type: "AlwaysTrueLeaf";
    } & AlwaysTrueLeaf)
  | ({
      type: "EvaluatedValueLeaf";
    } & EvaluatedValueLeaf)
  | ({
      type: "ExistenceLeaf";
    } & ExistenceLeaf)
  | ({
      type: "FuzzyOwnershipLeaf";
    } & FuzzyOwnershipLeaf)
  | ({
      type: "LogOpNode";
    } & LogOpNode)
  | ({
      type: "OwnershipLeaf";
    } & OwnershipLeaf)
  | ({
      type: "SingleParameterLeaf";
    } & SingleParameterLeaf)
  | ({
      type: "StaticParameterLeaf";
    } & StaticParameterLeaf)
  | ({
      type: "TwoStaticParametersLeaf";
    } & TwoStaticParametersLeaf);

/** RuleExecutionResult */
export interface RuleExecutionResult {
  result: boolean;
  evaluatedOwnership?: ArrayOwnerInTeam;
  evaluationLog?: OptionRuleEvaluationTree;
  gatheredData?: OptionMaterializedData;
  rule: RuleViewForExecution;
}

/**
 * RuleId
 * @pattern [^\s\\/]+
 */
export type RuleId = string;

/**
 * RuleId
 * @pattern [^\s\\/]+
 */
export type RuleId1 = string;

/** RuleType */

export const RuleType = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NonOwnershipRule: "NonOwnershipRule",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  OwnershipRule: "OwnershipRule",
} as const;
export type RuleType = "NonOwnershipRule" | "OwnershipRule";

/** RuleViewForExecution */
export interface RuleViewForExecution {
  ruleId: RuleId1;
  ruleType: RuleType;
  name: string;
  revision: Revision;
}

/** SalesforceAddToCampaignFailed */
export interface SalesforceAddToCampaignFailed {
  title: string;
  error: string;
  /** @format date-time */
  timestamp: string;
}

/** SalesforceAddToCampaignLogDetails */
export interface SalesforceAddToCampaignLogDetails {
  result?: SalesforceAddToCampaignResult;
}

/** SalesforceAddToCampaignResult */
export type SalesforceAddToCampaignResult = SalesforceAddToCampaignFailed | SalesforceAddToCampaignSuccess;

/** SalesforceAddToCampaignSuccess */
export interface SalesforceAddToCampaignSuccess {
  /** @format date-time */
  timestamp: string;
}

/** SalesforceContactUpserted */
/** @see {@link TimelineEventDiscriminator.SalesforceContactUpserted} */
export interface SalesforceContactUpserted {
  /** @format date-time */
  created: string;
  contactId: CrmContactId;
  status: SalesforceStatus;
  /** @see {@link TimelineEventDiscriminator.SalesforceContactUpserted} */
  type: typeof TimelineEventDiscriminator.SalesforceContactUpserted;
}

/** SalesforceCreateEventFailed */
export interface SalesforceCreateEventFailed {
  title: string;
  error: string;
  /** @format date-time */
  timestamp: string;
}

/** SalesforceCreateEventLogDetails */
export interface SalesforceCreateEventLogDetails {
  result?: SalesforceCreateEventResult;
}

/** SalesforceCreateEventResult */
export type SalesforceCreateEventResult = SalesforceCreateEventFailed | SalesforceCreateEventSuccess;

/** SalesforceCreateEventSuccess */
export interface SalesforceCreateEventSuccess {
  /** @format date-time */
  timestamp: string;
}

/** SalesforceData */
/** @see {@link CrmDataDiscriminator.SalesforceData} */
export interface SalesforceData {
  leadOrContact?: GuestMatch;
  /** @format date-time */
  syncedAt: string;
  /** @see {@link CrmDataDiscriminator.SalesforceData} */
  type: typeof CrmDataDiscriminator.SalesforceData;
}

/** SalesforceLeadUpserted */
/** @see {@link TimelineEventDiscriminator.SalesforceLeadUpserted} */
export interface SalesforceLeadUpserted {
  /** @format date-time */
  created: string;
  leadId: CrmLeadId;
  status: SalesforceStatus;
  /** @see {@link TimelineEventDiscriminator.SalesforceLeadUpserted} */
  type: typeof TimelineEventDiscriminator.SalesforceLeadUpserted;
}

/** SalesforceStatus */

export const SalesforceStatus = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Provided: "Provided",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Created: "Created",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Updated: "Updated",
} as const;
export type SalesforceStatus = "Provided" | "Created" | "Updated";

/** SalesforceUpdateFieldFailed */
export interface SalesforceUpdateFieldFailed {
  title: string;
  error: string;
  /** @format date-time */
  timestamp: string;
}

/** SalesforceUpdateFieldLogDetails */
export interface SalesforceUpdateFieldLogDetails {
  result?: SalesforceUpdateFieldResult;
}

/** SalesforceUpdateFieldResult */
export type SalesforceUpdateFieldResult = SalesforceUpdateFieldFailed | SalesforceUpdateFieldSuccess;

/** SalesforceUpdateFieldSuccess */
export interface SalesforceUpdateFieldSuccess {
  /** @format date-time */
  timestamp: string;
}

/** SalesforceUpdateOwnershipLogDetails */
export interface SalesforceUpdateOwnershipLogDetails {
  result?: SalesforceUpdateFieldResult;
}

/** SalesforceUpsertRecordFailed */
export interface SalesforceUpsertRecordFailed {
  title: string;
  error: string;
  /** @format date-time */
  timestamp: string;
}

/** SalesforceUpsertRecordLogDetails */
export interface SalesforceUpsertRecordLogDetails {
  result?: SalesforceUpsertRecordResult;
}

/** SalesforceUpsertRecordResult */
export type SalesforceUpsertRecordResult = SalesforceUpsertRecordFailed | SalesforceUpsertRecordSuccess;

/** SalesforceUpsertRecordSuccess */
export interface SalesforceUpsertRecordSuccess {
  /** @format date-time */
  timestamp: string;
}

/** ScheduleMeeting */
export interface ScheduleMeeting {
  assignee: SchedulingAssignee;
  meetingType: MeetingTypeRef;
  slotSelectionTimeout?: string;
  onSuccess: NodeExit;
  onFailure: NodeExit;
}

/** SchedulingAssignee */

export const SchedulingAssigneeDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Individual: "Individual",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LiveChat: "LiveChat",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Owner: "Owner",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Team: "Team",
} as const;
export type SchedulingAssigneeDiscriminator = "Individual" | "LiveChat" | "Owner" | "Team";

/** @see {@link SchedulingAssigneeDiscriminator} */
export type SchedulingAssignee =
  | ({
      type: "Individual";
    } & Individual)
  | ({
      type: "LiveChat";
    } & LiveChat)
  | ({
      type: "Owner";
    } & Owner)
  | ({
      type: "Team";
    } & Team);

/** SchedulingErrorCode */

export const SchedulingErrorCode = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Other: "Other",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Disabled: "Disabled",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NoAssigneeReturned: "NoAssigneeReturned",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NoAvailableAssignees: "NoAvailableAssignees",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ProspectLimitReached: "ProspectLimitReached",
} as const;
export type SchedulingErrorCode =
  | "Other"
  | "Disabled"
  | "NoAssigneeReturned"
  | "NoAvailableAssignees"
  | "ProspectLimitReached";

/** SelectDataFieldPicklistReplyAction */
/** @see {@link ConversationActionDiscriminator.SelectDataFieldPicklistReplyAction} */
export interface SelectDataFieldPicklistReplyAction {
  /** @minItems 1 */
  replies: DataFieldPicklistReplyButton[];
  /** @see {@link ConversationActionDiscriminator.SelectDataFieldPicklistReplyAction} */
  type: typeof ConversationActionDiscriminator.SelectDataFieldPicklistReplyAction;
}

/** SelectMeetingSlotAction */
/** @see {@link ConversationActionDiscriminator.SelectMeetingSlotAction} */
export interface SelectMeetingSlotAction {
  model: ScheduleMeeting;
  /** @minItems 1 */
  assignees: UserId[];
  /** @pattern .+@.+ */
  email?: string;
  /** @see {@link ConversationActionDiscriminator.SelectMeetingSlotAction} */
  type: typeof ConversationActionDiscriminator.SelectMeetingSlotAction;
}

/** SelectPlaybookWithConversationRequestDto */
export interface SelectPlaybookWithConversationRequestDto {
  /** @minItems 1 */
  playbookIds: string[];
  /** @format uuid */
  guestId: string;
  utm?: UtmParameters;
  targetedUrl?: string;
}

/** SelectPlaybookWithConversationResponseDto */
export interface SelectPlaybookWithConversationResponseDto {
  /** @format uuid */
  playbookId: string;
  displaySettings: DisplaySettings;
  conversationData?: ConversationData[];
}

/** SelectReplyAction */
/** @see {@link ConversationActionDiscriminator.SelectReplyAction} */
export interface SelectReplyAction {
  /** @minItems 1 */
  replies: ReplyButton[];
  /** @see {@link ConversationActionDiscriminator.SelectReplyAction} */
  type: typeof ConversationActionDiscriminator.SelectReplyAction;
}

/** SendDataFieldLogDetails */
export interface SendDataFieldLogDetails {
  fields?: FieldsSent;
}

/** SendMessageLogDetails */
export interface SendMessageLogDetails {
  /** @format date-time */
  timestamp: string;
}

/** SendReplyButtonsLogDetails */
export interface SendReplyButtonsLogDetails {
  buttonSelected?: ButtonSelected;
}

/** SendSlackNotificationLogDetails */
export interface SendSlackNotificationLogDetails {
  /** @format date-time */
  timestamp: string;
}

/** SessionExecutionLog */
export interface SessionExecutionLog {
  nodes?: NodeExecutionLog[];
  beforeJourneyPages: VisitedPagesLog;
  journeyPages: MapStringVisitedPagesLog;
}

/** SessionLog */
export interface SessionLog {
  /**
   * @format int32
   * @exclusiveMin 0
   */
  sessionNum: number;
  email: Email;
  relatedSessions?: RelatedSession[];
  /** @format uuid */
  playbookId: string;
  /** @format int32 */
  playbookVersion: number;
  /** @format date-time */
  triggeredAt: string;
  targetedUrl: string;
  respondedUrl?: string;
  conversation?: Conversation;
  meetings?: Meeting[];
  crmId?: CrmId;
  dataFields: MapDataFieldRefString;
  utms?: UtmParameters;
  execution: SessionExecutionLog;
}

/** SessionLogEntry */
export interface SessionLogEntry {
  /** @format uuid */
  guestId: string;
  /**
   * @format int32
   * @exclusiveMin 0
   */
  sessionNum: number;
  email: Email;
  /** @format uuid */
  playbookId: string;
  /** @pattern [^\s\\/]+ */
  conversationAssigneeId?: string;
  conversationAssignmentMethod?: ConversationAssignmentMethod;
  /** @pattern [^\s\\/]+ */
  meetingAssigneeId?: string;
  meetingAssignmentMethod?: MeetingAssignmentMethod;
  targetedPageUrl: string;
  interactedPageUrl?: string;
  respondedPageUrl?: string;
  meeting: MeetingOrigin;
  routedForLiveChat: boolean;
  repJoinedChat: boolean;
  errors: boolean;
  crmId?: CrmId;
  /** @format date-time */
  seenAt: string;
}

/** SessionsSummary */
export interface SessionsSummary {
  /** @format int64 */
  targeted: number;
  /** @format int64 */
  responded: number;
  /** @format int64 */
  withErrors: number;
}

/** Several */
/** @see {@link ReportingPlaybookFilterDiscriminator.Several} */
export interface Several {
  /** @minItems 1 */
  playbooks: string[];
  /** @see {@link ReportingPlaybookFilterDiscriminator.Several} */
  type: typeof ReportingPlaybookFilterDiscriminator.Several;
}

/** Several */
/** @see {@link ReportingUserFilterDiscriminator.Several} */
export interface Several1 {
  /** @minItems 1 */
  userIds: UserId[];
  /** @see {@link ReportingUserFilterDiscriminator.Several} */
  type: typeof ReportingUserFilterDiscriminator.Several;
}

/** ShortText */
/** @see {@link ChatDataFieldDataTypeDiscriminator.ShortText} */
export interface ShortText {
  /** @see {@link ChatDataFieldDataTypeDiscriminator.ShortText} */
  type: typeof ChatDataFieldDataTypeDiscriminator.ShortText;
}

/** ShortTextField */
/** @see {@link FormDataFieldDiscriminator.ShortTextField} */
export interface ShortTextField {
  /** @pattern [^\n]{1,250} */
  value: string;
  /** @see {@link FormDataFieldDiscriminator.ShortTextField} */
  type: typeof FormDataFieldDiscriminator.ShortTextField;
}

/** ShowToEveryone */
/** @see {@link LocationSettingsDiscriminator.ShowToEveryone} */
export interface ShowToEveryone {
  /** @see {@link LocationSettingsDiscriminator.ShowToEveryone} */
  type: typeof LocationSettingsDiscriminator.ShowToEveryone;
}

/** ShowUnderConditions */
/** @see {@link LocationSettingsDiscriminator.ShowUnderConditions} */
export interface ShowUnderConditions {
  rules: LocationConditionRequest;
  /** @see {@link LocationSettingsDiscriminator.ShowUnderConditions} */
  type: typeof LocationSettingsDiscriminator.ShowUnderConditions;
}

/** SimpleDataObject */
export type SimpleDataObject = MatchedObject | NormalDataObject | RelatedChildObjectRef;

/** SimpleMetadata */
export interface SimpleMetadata {
  /** @format date-time */
  createdAt: string;
  createdBy: CallerRef;
  /** @format date-time */
  updatedAt: string;
  updatedBy: CallerRef;
  /** @format int32 */
  revision: number;
}

/** Single */
/** @see {@link ReportingPlaybookFilterDiscriminator.Single} */
export interface Single {
  /** @format uuid */
  playbookId: string;
  /** @see {@link ReportingPlaybookFilterDiscriminator.Single} */
  type: typeof ReportingPlaybookFilterDiscriminator.Single;
}

/** Single */
/** @see {@link ReportingUserFilterDiscriminator.Single} */
export interface Single1 {
  userId: UserId;
  /** @see {@link ReportingUserFilterDiscriminator.Single} */
  type: typeof ReportingUserFilterDiscriminator.Single;
}

/** SingleOperator */

export const SingleOperator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NotEmpty: "notEmpty",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Empty: "empty",
} as const;
export type SingleOperator = "notEmpty" | "empty";

/** SingleParameterLeaf */
/** @see {@link RuleEvaluationTreeDiscriminator.SingleParameterLeaf} */
export interface SingleParameterLeaf {
  conditionId: ConditionId;
  value?: OptionStaticValue;
  operator: SingleOperator;
  evaluatedTo: boolean;
  error?: OptionComparisonError;
  valueSource: ValueSource;
  existenceValueSource?: OptionValueSource;
  /** @see {@link RuleEvaluationTreeDiscriminator.SingleParameterLeaf} */
  type: typeof RuleEvaluationTreeDiscriminator.SingleParameterLeaf;
}

/** Start */
/** @see {@link ConversationInputDiscriminator.Start} */
export interface Start {
  /** @see {@link ConversationInputDiscriminator.Start} */
  type: typeof ConversationInputDiscriminator.Start;
}

/** StartLiveChat */
/** @see {@link ConversationActionDiscriminator.StartLiveChat} */
export interface StartLiveChat {
  /** @see {@link ConversationActionDiscriminator.StartLiveChat} */
  type: typeof ConversationActionDiscriminator.StartLiveChat;
}

/** StaticPageValue */

export const StaticPageValueDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PageScrollValue: "PageScrollValue",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  TimeOnPageValue: "TimeOnPageValue",
} as const;
export type StaticPageValueDiscriminator = "PageScrollValue" | "TimeOnPageValue";

/** @see {@link StaticPageValueDiscriminator} */
export type StaticPageValue =
  | ({
      type: "PageScrollValue";
    } & PageScrollValue)
  | ({
      type: "TimeOnPageValue";
    } & TimeOnPageValue);

/** StaticParameterLeaf */
/** @see {@link RuleEvaluationTreeDiscriminator.StaticParameterLeaf} */
export interface StaticParameterLeaf {
  ruleReference?: OptionConditionId;
  conditionId: ConditionId;
  lhs?: OptionStaticValue;
  operator: Operator;
  rhs: StaticValue;
  evaluatedTo: boolean;
  error?: OptionComparisonError;
  valueSource: ValueSource;
  existenceValueSource?: OptionValueSource;
  /** @see {@link RuleEvaluationTreeDiscriminator.StaticParameterLeaf} */
  type: typeof RuleEvaluationTreeDiscriminator.StaticParameterLeaf;
}

/** StaticValue */
export type StaticValue = any;

/** StrictRoundRobin */
/** @see {@link ConversationAssignmentMethodDiscriminator.StrictRoundRobin} */
export interface StrictRoundRobin {
  /** @see {@link ConversationAssignmentMethodDiscriminator.StrictRoundRobin} */
  type: typeof ConversationAssignmentMethodDiscriminator.StrictRoundRobin;
}

/** StrictRoundRobin */
/** @see {@link MeetingAssignmentMethodDiscriminator.StrictRoundRobin} */
export interface StrictRoundRobin1 {
  /** @see {@link MeetingAssignmentMethodDiscriminator.StrictRoundRobin} */
  type: typeof MeetingAssignmentMethodDiscriminator.StrictRoundRobin;
}

/** SubmitFormAction */
/** @see {@link ConversationActionDiscriminator.SubmitFormAction} */
export interface SubmitFormAction {
  /** @minItems 1 */
  fields: SubmitFormEntry[];
  /** @see {@link ConversationActionDiscriminator.SubmitFormAction} */
  type: typeof ConversationActionDiscriminator.SubmitFormAction;
}

/** SubmitFormActionError */
/** @see {@link ConversationActionDiscriminator.SubmitFormActionError} */
export interface SubmitFormActionError {
  message: string;
  /** @see {@link ConversationActionDiscriminator.SubmitFormActionError} */
  type: typeof ConversationActionDiscriminator.SubmitFormActionError;
}

/** SubmitFormEntry */
export interface SubmitFormEntry {
  ref: DataFieldRef;
  fieldLabel: string;
  fieldDescription: string;
  dataTypeInfo: ChatDataFieldDataType;
}

/** SubmitFormEntry */
/** @see {@link ConversationActionDiscriminator.SubmitFormEntry} */
export interface SubmitFormEntry1 {
  ref: DataFieldRef;
  fieldLabel: string;
  fieldDescription: string;
  dataTypeInfo: ChatDataFieldDataType;
  /** @see {@link ConversationActionDiscriminator.SubmitFormEntry} */
  type: typeof ConversationActionDiscriminator.SubmitFormEntry;
}

/** Success */
/** @see {@link NodeExecutionStatusLogDiscriminator.Success} */
export interface Success {
  /** @see {@link NodeExecutionStatusLogDiscriminator.Success} */
  type: typeof NodeExecutionStatusLogDiscriminator.Success;
}

/** SystemConversationAssigned */
/** @see {@link PayloadOutDiscriminator.SystemConversationAssigned} */
export interface SystemConversationAssigned {
  source: ConversationAssignedSource;
  toUser: UserId;
  /** @see {@link PayloadOutDiscriminator.SystemConversationAssigned} */
  type: typeof PayloadOutDiscriminator.SystemConversationAssigned;
}

/** SystemConversationDeadline */
/** @see {@link PayloadOutDiscriminator.SystemConversationDeadline} */
export interface SystemConversationDeadline {
  /** @minItems 1 */
  toUsers: UserId[];
  /** @format date-time */
  waitForRepStartTime: string;
  /** @format date-time */
  responseDeadline: string;
  /** @see {@link PayloadOutDiscriminator.SystemConversationDeadline} */
  type: typeof PayloadOutDiscriminator.SystemConversationDeadline;
}

/** SystemConversationReassigned */
/** @see {@link PayloadOutDiscriminator.SystemConversationReassigned} */
export interface SystemConversationReassigned {
  fromUser: UserId;
  toUser: UserId;
  /** @see {@link PayloadOutDiscriminator.SystemConversationReassigned} */
  type: typeof PayloadOutDiscriminator.SystemConversationReassigned;
}

/** SystemConversationReassignedFromTeam */
/** @see {@link PayloadOutDiscriminator.SystemConversationReassignedFromTeam} */
export interface SystemConversationReassignedFromTeam {
  fromTeam: TeamId;
  toUser: UserId;
  /** @see {@link PayloadOutDiscriminator.SystemConversationReassignedFromTeam} */
  type: typeof PayloadOutDiscriminator.SystemConversationReassignedFromTeam;
}

/** SystemData */
export interface SystemData {
  assignee?: LiveChatAssignment;
  repCandidacy?: RepCandidacy;
  /** @minItems 1 */
  assigneeLog?: AssigneeLogEntry[];
  /** @pattern [^\s\\/]+ */
  ownerId?: string;
  source?: string;
  meeting?: MeetingState;
  /** @minItems 1 */
  routingLog?: RoutingLogEntry[];
  transcriptTask?: TranscriptTask;
}

/** SystemDataValue */
/** @see {@link GuestValueDiscriminator.SystemDataValue} */
export interface SystemDataValue {
  /** @minLength 1 */
  value: string;
  /** @see {@link GuestValueDiscriminator.SystemDataValue} */
  type: typeof GuestValueDiscriminator.SystemDataValue;
}

/** SystemEnvelope */
/** @see {@link EnvelopeInDiscriminator.SystemEnvelope} */
export interface SystemEnvelope {
  /** @see {@link EnvelopeInDiscriminator.SystemEnvelope} */
  type: typeof EnvelopeInDiscriminator.SystemEnvelope;
}

/** SystemEnvelopeOut */
/** @see {@link EnvelopeOutDiscriminator.SystemEnvelopeOut} */
export interface SystemEnvelopeOut {
  payload: PayloadOut;
  /** @format date-time */
  createdAt: string;
  /** @format int64 */
  protocolVersion: number;
  baggage?: MapStringString;
  /** @see {@link EnvelopeOutDiscriminator.SystemEnvelopeOut} */
  type: typeof EnvelopeOutDiscriminator.SystemEnvelopeOut;
}

/** SystemMessage */
/** @see {@link PayloadOutDiscriminator.SystemMessage} */
export interface SystemMessage {
  /** @format uuid */
  id: string;
  payload: SystemMessagePayload;
  /** @see {@link PayloadOutDiscriminator.SystemMessage} */
  type: typeof PayloadOutDiscriminator.SystemMessage;
}

/** SystemMessagePayload */

export const SystemMessagePayloadDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ConversationSessionExpired: "ConversationSessionExpired",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MeetingSchedulingFailed: "MeetingSchedulingFailed",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MeetingSchedulingRequested: "MeetingSchedulingRequested",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemConversationAssigned: "SystemConversationAssigned",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemConversationDeadline: "SystemConversationDeadline",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemConversationReassigned: "SystemConversationReassigned",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemConversationReassignedFromTeam: "SystemConversationReassignedFromTeam",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SystemRepsHaveFailedToRespond: "SystemRepsHaveFailedToRespond",
} as const;
export type SystemMessagePayloadDiscriminator =
  | "ConversationSessionExpired"
  | "MeetingSchedulingFailed"
  | "MeetingSchedulingRequested"
  | "SystemConversationAssigned"
  | "SystemConversationDeadline"
  | "SystemConversationReassigned"
  | "SystemConversationReassignedFromTeam"
  | "SystemRepsHaveFailedToRespond";

/** @see {@link SystemMessagePayloadDiscriminator} */
export type SystemMessagePayload =
  | ({
      type: "ConversationSessionExpired";
    } & ConversationSessionExpired)
  | ({
      type: "MeetingSchedulingFailed";
    } & MeetingSchedulingFailed)
  | ({
      type: "MeetingSchedulingRequested";
    } & MeetingSchedulingRequested)
  | ({
      type: "SystemConversationAssigned";
    } & SystemConversationAssigned)
  | ({
      type: "SystemConversationDeadline";
    } & SystemConversationDeadline)
  | ({
      type: "SystemConversationReassigned";
    } & SystemConversationReassigned)
  | ({
      type: "SystemConversationReassignedFromTeam";
    } & SystemConversationReassignedFromTeam)
  | ({
      type: "SystemRepsHaveFailedToRespond";
    } & SystemRepsHaveFailedToRespond);

/** SystemRepsHaveFailedToRespond */
/** @see {@link SystemMessagePayloadDiscriminator.SystemRepsHaveFailedToRespond} */
export interface SystemRepsHaveFailedToRespond {
  /** @minItems 1 */
  reps: UserId[];
  /** @see {@link SystemMessagePayloadDiscriminator.SystemRepsHaveFailedToRespond} */
  type: typeof SystemMessagePayloadDiscriminator.SystemRepsHaveFailedToRespond;
}

/** Team */
/** @see {@link SchedulingAssigneeDiscriminator.Team} */
export interface Team {
  distributionId: DistributionId;
  /** @see {@link SchedulingAssigneeDiscriminator.Team} */
  type: typeof SchedulingAssigneeDiscriminator.Team;
}

/** Team */
/** @see {@link AnalyticsSchedulingAssigneeDiscriminator.Team} */
export interface Team1 {
  distributionId: DistributionId;
  roundRobinKind?: RoundRobinKind;
  /** @see {@link AnalyticsSchedulingAssigneeDiscriminator.Team} */
  type: typeof AnalyticsSchedulingAssigneeDiscriminator.Team;
}

/** Team */
export interface Team2 {
  teamId: TeamId;
}

/** TeamCouldNotBeResolved */
/** @see {@link ComparisonErrorDiscriminator.TeamCouldNotBeResolved} */
export interface TeamCouldNotBeResolved {
  teamId?: OptionTeamId;
  /** @see {@link ComparisonErrorDiscriminator.TeamCouldNotBeResolved} */
  type: typeof ComparisonErrorDiscriminator.TeamCouldNotBeResolved;
}

/** TeamFirstToInteract */
/** @see {@link LiveChatAssignmentDiscriminator.TeamFirstToInteract} */
export interface TeamFirstToInteract {
  teamId: TeamId;
  /** @minItems 1 */
  assignees: UserId[];
  /** @format date-time */
  waitForRepStartTime?: string;
  /** @format date-time */
  responseDeadline?: string;
  /** @see {@link LiveChatAssignmentDiscriminator.TeamFirstToInteract} */
  type: typeof LiveChatAssignmentDiscriminator.TeamFirstToInteract;
}

/**
 * TeamId
 * @pattern [^\s\\/]+
 */
export type TeamId = string;

/**
 * TeamId
 * @pattern [^\s\\/]+
 */
export type TeamId1 = string;

/** TeamLiveChatRouting */
export interface TeamLiveChatRouting {
  assigneeId: UserId;
  online: boolean;
  distributionId: DistributionId;
}

/** TeamMeeting */
export interface TeamMeeting {
  assigneeId: UserId;
  distributionId: DistributionId;
}

/** Terminate */
/** @see {@link NodeExitDiscriminator.Terminate} */
export interface Terminate {
  /** @see {@link NodeExitDiscriminator.Terminate} */
  type: typeof NodeExitDiscriminator.Terminate;
}

/** TerminateConversation */
/** @see {@link ConversationActionDiscriminator.TerminateConversation} */
export interface TerminateConversation {
  /** @see {@link ConversationActionDiscriminator.TerminateConversation} */
  type: typeof ConversationActionDiscriminator.TerminateConversation;
}

/** Text */
/** @see {@link MessagePartDiscriminator.Text} */
export interface Text {
  text: string;
  /** @see {@link MessagePartDiscriminator.Text} */
  type: typeof MessagePartDiscriminator.Text;
}

/** ThisMonth */
/** @see {@link ReportingTimeframeDiscriminator.ThisMonth} */
export interface ThisMonth {
  /** @see {@link ReportingTimeframeDiscriminator.ThisMonth} */
  type: typeof ReportingTimeframeDiscriminator.ThisMonth;
}

/** ThisWeek */
/** @see {@link ReportingTimeframeDiscriminator.ThisWeek} */
export interface ThisWeek {
  /** @see {@link ReportingTimeframeDiscriminator.ThisWeek} */
  type: typeof ReportingTimeframeDiscriminator.ThisWeek;
}

/** ThisYear */
/** @see {@link ReportingTimeframeDiscriminator.ThisYear} */
export interface ThisYear {
  /** @see {@link ReportingTimeframeDiscriminator.ThisYear} */
  type: typeof ReportingTimeframeDiscriminator.ThisYear;
}

/** TimeInterval */
export interface TimeInterval {
  /** @format date-time */
  startsAt: string;
  duration: string;
}

/** TimeOnPageValue */
/** @see {@link StaticPageValueDiscriminator.TimeOnPageValue} */
export interface TimeOnPageValue {
  duration: string;
  /** @see {@link StaticPageValueDiscriminator.TimeOnPageValue} */
  type: typeof StaticPageValueDiscriminator.TimeOnPageValue;
}

/** TimeRange */
/** @see {@link EvaluatedResultDiscriminator.TimeRange} */
export interface TimeRange {
  /** @format date-time */
  start: string;
  /** @format date-time */
  end: string;
  /** @format date-time */
  evaluationTime: string;
  evaluationTimeZone: string;
  /** @see {@link EvaluatedResultDiscriminator.TimeRange} */
  type: typeof EvaluatedResultDiscriminator.TimeRange;
}

/** TimelineEvent */

export const TimelineEventDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AvailableUsersFound: "AvailableUsersFound",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  BookMeetingReached: "BookMeetingReached",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  GuestRerouted: "GuestRerouted",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  LiveChatReached: "LiveChatReached",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  MeetingBookedSuccess: "MeetingBookedSuccess",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NoUserIsAvailable: "NoUserIsAvailable",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  NodeReached: "NodeReached",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PageBrowsed: "PageBrowsed",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PlaybookInteractedWith: "PlaybookInteractedWith",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PlaybookLaunched: "PlaybookLaunched",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  PlaybookTriggered: "PlaybookTriggered",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Reassigned: "Reassigned",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ReceivedEmail: "ReceivedEmail",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  RepFailedToEngage: "RepFailedToEngage",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SalesforceContactUpserted: "SalesforceContactUpserted",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SalesforceLeadUpserted: "SalesforceLeadUpserted",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  WidgetClosed: "WidgetClosed",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  WidgetDisplayed: "WidgetDisplayed",
} as const;
export type TimelineEventDiscriminator =
  | "AvailableUsersFound"
  | "BookMeetingReached"
  | "GuestRerouted"
  | "LiveChatReached"
  | "MeetingBookedSuccess"
  | "NoUserIsAvailable"
  | "NodeReached"
  | "PageBrowsed"
  | "PlaybookInteractedWith"
  | "PlaybookLaunched"
  | "PlaybookTriggered"
  | "Reassigned"
  | "ReceivedEmail"
  | "RepFailedToEngage"
  | "SalesforceContactUpserted"
  | "SalesforceLeadUpserted"
  | "WidgetClosed"
  | "WidgetDisplayed";

/** @see {@link TimelineEventDiscriminator} */
export type TimelineEvent =
  | ({
      type: "AvailableUsersFound";
    } & AvailableUsersFound)
  | ({
      type: "BookMeetingReached";
    } & BookMeetingReached)
  | ({
      type: "GuestRerouted";
    } & GuestRerouted)
  | ({
      type: "LiveChatReached";
    } & LiveChatReached)
  | ({
      type: "MeetingBookedSuccess";
    } & MeetingBookedSuccess)
  | ({
      type: "NoUserIsAvailable";
    } & NoUserIsAvailable)
  | ({
      type: "NodeReached";
    } & NodeReached)
  | ({
      type: "PageBrowsed";
    } & PageBrowsed)
  | ({
      type: "PlaybookInteractedWith";
    } & PlaybookInteractedWith)
  | ({
      type: "PlaybookLaunched";
    } & PlaybookLaunched)
  | ({
      type: "PlaybookTriggered";
    } & PlaybookTriggered)
  | ({
      type: "Reassigned";
    } & Reassigned)
  | ({
      type: "ReceivedEmail";
    } & ReceivedEmail)
  | ({
      type: "RepFailedToEngage";
    } & RepFailedToEngage)
  | ({
      type: "SalesforceContactUpserted";
    } & SalesforceContactUpserted)
  | ({
      type: "SalesforceLeadUpserted";
    } & SalesforceLeadUpserted)
  | ({
      type: "WidgetClosed";
    } & WidgetClosed1)
  | ({
      type: "WidgetDisplayed";
    } & WidgetDisplayed);

/** TinyTeamView */
export interface TinyTeamView {
  teamId: TeamId1;
  revision: Revision;
}

/** Today */
/** @see {@link ReportingTimeframeDiscriminator.Today} */
export interface Today {
  /** @see {@link ReportingTimeframeDiscriminator.Today} */
  type: typeof ReportingTimeframeDiscriminator.Today;
}

/** TranscriptTask */
export interface TranscriptTask {
  /** @pattern ^(00T)[a-zA-Z0-9]{15} */
  transcriptTaskId?: string;
}

/** TrueFalse */
/** @see {@link ChatDataFieldDataTypeDiscriminator.TrueFalse} */
export interface TrueFalse {
  /** @see {@link ChatDataFieldDataTypeDiscriminator.TrueFalse} */
  type: typeof ChatDataFieldDataTypeDiscriminator.TrueFalse;
}

/** TrueFalseField */
/** @see {@link FormDataFieldDiscriminator.TrueFalseField} */
export interface TrueFalseField {
  value: boolean;
  /** @see {@link FormDataFieldDiscriminator.TrueFalseField} */
  type: typeof FormDataFieldDiscriminator.TrueFalseField;
}

/** TwoStaticParametersLeaf */
/** @see {@link RuleEvaluationTreeDiscriminator.TwoStaticParametersLeaf} */
export interface TwoStaticParametersLeaf {
  conditionId: ConditionId;
  lhs?: OptionStaticValue;
  operator: Operator;
  rhs?: OptionStaticValue;
  evaluatedTo: boolean;
  error?: OptionComparisonError;
  lhsValueSource: ValueSource;
  rhsValueSource: ValueSource;
  lhsExistenceValueSource?: OptionValueSource;
  rhsExistenceValueSource?: OptionValueSource;
  /** @see {@link RuleEvaluationTreeDiscriminator.TwoStaticParametersLeaf} */
  type: typeof RuleEvaluationTreeDiscriminator.TwoStaticParametersLeaf;
}

/** UndefinedOperationBetweenTypes */
/** @see {@link ComparisonErrorDiscriminator.UndefinedOperationBetweenTypes} */
export interface UndefinedOperationBetweenTypes {
  lhsType: string;
  rhsType: string;
  operator: Operator;
  /** @see {@link ComparisonErrorDiscriminator.UndefinedOperationBetweenTypes} */
  type: typeof ComparisonErrorDiscriminator.UndefinedOperationBetweenTypes;
}

/** Unknown */
/** @see {@link LiveChatAssignmentDiscriminator.Unknown} */
export interface Unknown {
  /** @see {@link LiveChatAssignmentDiscriminator.Unknown} */
  type: typeof LiveChatAssignmentDiscriminator.Unknown;
}

/** UrlOperator */

export const UrlOperator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SymbolEqual: "=",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  SymbolNotEqual: "!=",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  Contains: "contains",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  DoesNotContain: "doesNotContain",
} as const;
export type UrlOperator = "=" | "!=" | "contains" | "doesNotContain";

/** UrlRuleValue */
export interface UrlRuleValue {
  value: string;
}

/** UrlValueCondition */
/** @see {@link LocationConditionRequestDiscriminator.UrlValueCondition} */
export interface UrlValueCondition {
  /** @pattern [^\s\\/]+ */
  conditionId: string;
  operator: UrlOperator;
  value: UrlRuleValue;
  /** @see {@link LocationConditionRequestDiscriminator.UrlValueCondition} */
  type: typeof LocationConditionRequestDiscriminator.UrlValueCondition;
}

/** User */
/** @see {@link CallerRefDiscriminator.User} */
export interface User {
  id: UserId;
  /** @see {@link CallerRefDiscriminator.User} */
  type: typeof CallerRefDiscriminator.User;
}

/** UserDescribeRoomResponseDto */
export interface UserDescribeRoomResponseDto {
  /** @format date-time */
  waitForRepStartTime?: string;
  /** @format date-time */
  responseDeadline?: string;
}

/** UserDescribeRoomsResponseDto */
export interface UserDescribeRoomsResponseDto {
  rooms: MapStringUserDescribeRoomResponseDto;
}

/**
 * UserId
 * @pattern [^\s\\/]+
 */
export type UserId = string;

/**
 * UserId
 * @pattern [^\s\\/]+
 */
export type UserId1 = string;

/** UserStatsRequest */
export interface UserStatsRequest {
  playbookFilter: ReportingPlaybookFilter;
  userFilter: ReportingUserFilter;
  timeframe: ReportingTimeframe;
}

/** UserStatsResponse */
export interface UserStatsResponse {
  /** @format double */
  averageResponseTime: number;
  userTimes: MapUserIdNumber;
}

/** UtmParameters */
export interface UtmParameters {
  /** @minLength 1 */
  campaign?: string;
  /** @minLength 1 */
  source?: string;
  /** @minLength 1 */
  medium?: string;
  /** @minLength 1 */
  term?: string;
  /** @minLength 1 */
  content?: string;
}

/** ValueFromDataSource */
/** @see {@link ValueSourceDiscriminator.ValueFromDataSource} */
export interface ValueFromDataSource {
  ref: AliasedDataReference;
  resolvedReference?: OptionDataReference;
  dataObjectId?: OptionAnyDataObjectId;
  /** @see {@link ValueSourceDiscriminator.ValueFromDataSource} */
  type: typeof ValueSourceDiscriminator.ValueFromDataSource;
}

/** ValueSource */

export const ValueSourceDiscriminator = {
  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  AnyValueFromDataSource: "AnyValueFromDataSource",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  EvaluatedValue: "EvaluatedValue",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  IdFromDataSource: "IdFromDataSource",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  KnownValue: "KnownValue",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  OwnershipValueFromDataSource: "OwnershipValueFromDataSource",

  /**
   * @deprecated Discriminator consts are deprecated. Please use raw string instead
   */
  ValueFromDataSource: "ValueFromDataSource",
} as const;
export type ValueSourceDiscriminator =
  | "AnyValueFromDataSource"
  | "EvaluatedValue"
  | "IdFromDataSource"
  | "KnownValue"
  | "OwnershipValueFromDataSource"
  | "ValueFromDataSource";

/** @see {@link ValueSourceDiscriminator} */
export type ValueSource =
  | ({
      type: "AnyValueFromDataSource";
    } & AnyValueFromDataSource)
  | ({
      type: "EvaluatedValue";
    } & EvaluatedValue)
  | ({
      type: "IdFromDataSource";
    } & IdFromDataSource)
  | ({
      type: "KnownValue";
    } & KnownValue)
  | ({
      type: "OwnershipValueFromDataSource";
    } & OwnershipValueFromDataSource)
  | ({
      type: "ValueFromDataSource";
    } & ValueFromDataSource);

/** Video */
/** @see {@link MessagePartDiscriminator.Video} */
export interface Video {
  url: string;
  caption?: string;
  /** @see {@link MessagePartDiscriminator.Video} */
  type: typeof MessagePartDiscriminator.Video;
}

/** VisitedPageLog */
export interface VisitedPageLog {
  url: string;
  /** @format int32 */
  durationSeconds?: number;
  /** @format date-time */
  timestamp: string;
}

/** VisitedPagesLog */
export interface VisitedPagesLog {
  pages?: VisitedPageLog[];
}

/** WaitForRepLogDetails */
export interface WaitForRepLogDetails {
  waitingAssignee: WaitingForRepAssignee;
  result?: WaitingForRepResult;
  /** @format date-time */
  timestamp: string;
}

/** WaitingForRepAssignee */
export type WaitingForRepAssignee = Individual5 | Team2;

/** WaitingForRepHasTimedout */
/** @see {@link ConversationInputDiscriminator.WaitingForRepHasTimedout} */
export interface WaitingForRepHasTimedout {
  /** @minItems 1 */
  reps: UserId[];
  /** @see {@link ConversationInputDiscriminator.WaitingForRepHasTimedout} */
  type: typeof ConversationInputDiscriminator.WaitingForRepHasTimedout;
}

/** WaitingForRepResult */
export type WaitingForRepResult = RepJoined | RepNotJoined;

/** WidgetAppearanceSettings */
export interface WidgetAppearanceSettings {
  workspaceId: WorkspaceId;
  settings: any;
  /** @format int32 */
  version: number;
}

/** WidgetClosed */
/** @see {@link FrontendEventRequestDiscriminator.WidgetClosed} */
export interface WidgetClosed {
  /** @see {@link FrontendEventRequestDiscriminator.WidgetClosed} */
  type: typeof FrontendEventRequestDiscriminator.WidgetClosed;
}

/** WidgetClosed */
/** @see {@link TimelineEventDiscriminator.WidgetClosed} */
export interface WidgetClosed1 {
  /** @format date-time */
  created: string;
  /** @see {@link TimelineEventDiscriminator.WidgetClosed} */
  type: typeof TimelineEventDiscriminator.WidgetClosed;
}

/** WidgetDisplayed */
/** @see {@link TimelineEventDiscriminator.WidgetDisplayed} */
export interface WidgetDisplayed {
  /** @format date-time */
  created: string;
  /** @see {@link TimelineEventDiscriminator.WidgetDisplayed} */
  type: typeof TimelineEventDiscriminator.WidgetDisplayed;
}

/**
 * WorkspaceId
 * @pattern [^\s\\/]+
 */
export type WorkspaceId = string;

/** Yesterday */
/** @see {@link ReportingTimeframeDiscriminator.Yesterday} */
export interface Yesterday {
  /** @see {@link ReportingTimeframeDiscriminator.Yesterday} */
  type: typeof ReportingTimeframeDiscriminator.Yesterday;
}

/** ZoomOneTimeLink */
/** @see {@link PickedMeetingLocationDiscriminator.ZoomOneTimeLink} */
export interface ZoomOneTimeLink {
  /** @see {@link PickedMeetingLocationDiscriminator.ZoomOneTimeLink} */
  type: typeof PickedMeetingLocationDiscriminator.ZoomOneTimeLink;
}
